const lcmsJcamp2 = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (1.8.0)
##DATA TYPE=MASS SPECTRUM
##DATA CLASS=NTUPLES
##ORIGIN=
##OWNER=
##XUNITS=m/z
##YUNITS=Intensity
##SOFTWARE=openlab
##SCAN_MODE=positiv
##TYPE=ms spectrum
##NTUPLES=MULTIDIMENSIONAL
##VAR_NAME=T, m/z, Intensity
##SYMBOL=T, X, Y
##VAR_TYPE=PAGE, X, Y
##VAR_DIM=1200, 1189, 1189
##UNITS=, m/z, Intensity
##PAGE=T= 0.004666666666666667
##XYDATA=(XY..XY)
103.5, 15.371621621621621
104.30000305175781, 17.48310810810811
104.69999694824219, 17.736486486486488
105.4000015258789, 15.287162162162161
112.5999984741211, 0.2533783783783784
114.19999694824219, 13.091216216216216
114.9000015258789, 16.300675675675674
115.9000015258789, 14.442567567567567
116.5999984741211, 12.5
117.80000305175781, 2.7871621621621623
123.0999984741211, 1.689189189189189
124.5, 7.601351351351351
125.5999984741211, 13.85135135135135
126.69999694824219, 12.66891891891892
127.4000015258789, 11.317567567567567
128.0, 10.72635135135135
129.39999389648438, 1.2668918918918919
134.39999389648438, 2.1114864864864864
135.3000030517578, 10.135135135135135
136.10000610351562, 13.513513513513512
136.60000610351562, 11.317567567567567
137.3000030517578, 13.513513513513512
137.6999969482422, 11.06418918918919
138.8000030517578, 10.72635135135135
139.60000610351562, 6.672297297297297
140.39999389648438, 3.209459459459459
146.0, 9.20608108108108
147.0, 15.625
147.89999389648438, 19.425675675675674
148.6999969482422, 15.45608108108108
155.6999969482422, 1.097972972972973
158.0, 13.260135135135135
159.10000610351562, 17.989864864864863
160.10000610351562, 17.14527027027027
161.10000610351562, 8.783783783783784
167.89999389648438, 7.263513513513513
169.10000610351562, 11.486486486486486
170.0, 14.695945945945946
170.6999969482422, 16.300675675675674
171.3000030517578, 17.652027027027028
172.60000610351562, 2.7027027027027026
178.10000610351562, 1.689189189189189
179.1999969482422, 14.611486486486486
180.39999389648438, 16.385135135135133
181.0, 14.02027027027027
182.39999389648438, 12.58445945945946
183.10000610351562, 8.277027027027026
184.10000610351562, 1.1824324324324325
189.3000030517578, 7.010135135135135
190.3000030517578, 13.260135135135135
191.39999389648438, 18.3277027027027
192.1999969482422, 16.80743243243243
193.1999969482422, 11.908783783783784
199.89999389648438, 1.097972972972973
201.8000030517578, 15.118243243243242
202.6999969482422, 18.75
203.6999969482422, 17.820945945945944
211.3000030517578, 6.672297297297297
212.60000610351562, 10.219594594594595
213.5, 10.89527027027027
213.8000030517578, 10.81081081081081
214.89999389648438, 19.594594594594593
223.3000030517578, 18.75
224.10000610351562, 17.905405405405403
225.10000610351562, 13.682432432432432
226.3000030517578, 7.347972972972973
227.0, 3.4628378378378377
234.10000610351562, 22.804054054054053
235.1999969482422, 19.341216216216214
235.89999389648438, 15.287162162162161
242.8000030517578, 3.5472972972972974
244.10000610351562, 9.375
244.6999969482422, 16.80743243243243
246.10000610351562, 23.14189189189189
246.8000030517578, 18.074324324324323
247.89999389648438, 8.530405405405405
254.3000030517578, 8.614864864864865
255.3000030517578, 15.202702702702702
256.29998779296875, 12.246621621621621
256.79998779296875, 10.557432432432432
257.6000061035156, 14.18918918918919
258.3999938964844, 10.472972972972972
259.6000061035156, 3.378378378378378
266.1000061035156, 15.625
267.1000061035156, 17.39864864864865
267.70001220703125, 16.0472972972973
268.20001220703125, 14.611486486486486
269.29998779296875, 4.898648648648648
269.79998779296875, 4.72972972972973
277.5, 15.79391891891892
277.8999938964844, 15.54054054054054
278.70001220703125, 17.56756756756757
287.5, 7.347972972972973
288.20001220703125, 12.162162162162161
288.79998779296875, 13.344594594594595
289.70001220703125, 14.442567567567567
290.29998779296875, 16.97635135135135
297.1000061035156, 2.1114864864864864
298.3999938964844, 10.97972972972973
299.1000061035156, 9.037162162162161
299.79998779296875, 9.628378378378379
300.6000061035156, 11.739864864864865
302.0, 9.20608108108108
303.0, 4.476351351351351
307.8999938964844, 0.08445945945945946
309.6000061035156, 14.18918918918919
310.79998779296875, 13.85135135135135
311.70001220703125, 2.956081081081081
313.70001220703125, 2.2804054054054053
314.79998779296875, 3.4628378378378377
319.8999938964844, 7.85472972972973
320.5, 9.797297297297296
321.29998779296875, 8.952702702702702
322.29998779296875, 4.3074324324324325
323.0, 3.885135135135135
324.29998779296875, 1.8581081081081081
325.8999938964844, 5.658783783783783
329.20001220703125, 49.5777027027027
329.8999938964844, 5.996621621621621
330.6000061035156, 6.503378378378378
331.29998779296875, 5.827702702702703
332.79998779296875, 2.8716216216216215
334.20001220703125, 7.6858108108108105
334.79998779296875, 5.320945945945946
335.79998779296875, 7.601351351351351
336.79998779296875, 6.841216216216216
339.79998779296875, 43.91891891891892
340.6000061035156, 6.16554054054054
341.29998779296875, 8.952702702702702
342.29998779296875, 6.16554054054054
343.29998779296875, 4.054054054054054
345.3999938964844, 3.8006756756756754
346.0, 5.658783783783783
346.6000061035156, 3.125
350.0, 7.939189189189189
350.6000061035156, 9.712837837837837
351.5, 10.050675675675675
352.0, 9.881756756756756
353.6000061035156, 5.912162162162162
356.1000061035156, 2.1114864864864864
357.1000061035156, 7.601351351351351
358.5, 9.121621621621621
359.0, 3.9695945945945943
361.3999938964844, 39.7804054054054
362.8999938964844, 4.8141891891891895
363.8999938964844, 3.4628378378378377
365.0, 2.195945945945946
366.79998779296875, 2.618243243243243
367.79998779296875, 2.5337837837837838
372.20001220703125, 30.91216216216216
373.0, 7.263513513513513
373.70001220703125, 4.391891891891892
374.79998779296875, 3.6317567567567566
377.29998779296875, 4.8141891891891895
378.1000061035156, 3.9695945945945943
378.8999938964844, 8.02364864864865
379.8999938964844, 9.45945945945946
382.79998779296875, 36.148648648648646
384.8999938964844, 5.574324324324325
385.70001220703125, 1.1824324324324325
390.20001220703125, 7.85472972972973
390.8999938964844, 4.138513513513513
393.1000061035156, 16.216216216216218
393.5, 14.27364864864865
394.5, 4.3074324324324325
395.6000061035156, 2.8716216216216215
396.1000061035156, 3.0405405405405403
396.5, 2.8716216216216215
397.79998779296875, 0.5067567567567568
400.0, 4.138513513513513
400.6000061035156, 0.6756756756756757
401.6000061035156, 10.641891891891891
404.5, 46.79054054054054
405.29998779296875, 9.29054054054054
406.8999938964844, 0.8445945945945945
411.70001220703125, 1.4358108108108107
412.6000061035156, 3.6317567567567566
415.29998779296875, 32.0945945945946
420.79998779296875, 0.0
422.0, 5.489864864864865
422.6000061035156, 14.442567567567567
423.3999938964844, 10.304054054054054
426.1000061035156, 45.608108108108105
427.79998779296875, 5.405405405405405
433.20001220703125, 7.516891891891892
434.20001220703125, 7.85472972972973
436.0, 22.804054054054053
436.6000061035156, 15.202702702702702
438.29998779296875, 7.094594594594595
439.0, 3.8006756756756754
443.6000061035156, 3.209459459459459
444.3999938964844, 3.885135135135135
444.79998779296875, 4.138513513513513
445.1000061035156, 3.9695945945945943
447.3999938964844, 49.23986486486486
449.20001220703125, 4.5608108108108105
454.79998779296875, 0.16891891891891891
455.5, 2.5337837837837838
458.3999938964844, 22.21283783783784
459.20001220703125, 21.875
460.3999938964844, 9.037162162162161
465.1000061035156, 2.195945945945946
466.70001220703125, 9.037162162162161
469.1000061035156, 54.729729729729726
470.0, 15.54054054054054
470.5, 13.006756756756756
477.20001220703125, 7.77027027027027
477.8999938964844, 3.8006756756756754
479.20001220703125, 17.31418918918919
480.20001220703125, 38.597972972972975
481.1000061035156, 17.48310810810811
481.8999938964844, 7.010135135135135
482.6000061035156, 3.378378378378378
488.0, 4.8141891891891895
490.6000061035156, 56.25
491.5, 20.52364864864865
498.70001220703125, 2.2804054054054053
499.29998779296875, 0.5067567567567568
501.29998779296875, 26.77364864864865
502.70001220703125, 18.66554054054054
503.0, 19.341216216216214
504.1000061035156, 5.658783783783783
509.29998779296875, 7.77027027027027
512.2000122070312, 66.97635135135135
513.5999755859375, 14.18918918918919
520.7000122070312, 9.29054054054054
522.5, 23.986486486486484
523.0, 26.097972972972972
523.7000122070312, 30.91216216216216
525.2000122070312, 11.317567567567567
530.5, 0.33783783783783783
531.2999877929688, 4.222972972972973
533.7000122070312, 68.24324324324324
534.5, 26.52027027027027
541.7000122070312, 2.5337837837837838
544.5, 40.11824324324324
545.2000122070312, 37.5
546.0999755859375, 28.125
553.0999755859375, 8.614864864864865
555.2999877929688, 65.87837837837837
564.4000244140625, 5.743243243243243
565.5, 26.43581081081081
566.2999877929688, 34.03716216216216
567.0, 30.236486486486484
567.7999877929688, 28.716216216216214
574.2999877929688, 2.195945945945946
576.7000122070312, 68.3277027027027
578.5999755859375, 19.594594594594593
587.5999755859375, 61.402027027027025
588.5999755859375, 34.54391891891892
589.2000122070312, 33.9527027027027
590.2999877929688, 16.385135135135133
596.2999877929688, 4.5608108108108105
598.2999877929688, 72.63513513513513
609.0, 46.11486486486486
610.5, 39.86486486486486
619.7999877929688, 69.25675675675676
620.7999877929688, 36.064189189189186
622.2000122070312, 16.300675675675674
630.5999755859375, 38.00675675675676
631.2999877929688, 37.33108108108108
632.2000122070312, 30.8277027027027
632.7000122070312, 33.69932432432432
641.4000244140625, 69.84797297297297
644.7000122070312, 7.1790540540540535
652.2000122070312, 56.08108108108108
653.0999755859375, 58.61486486486486
653.9000244140625, 42.398648648648646
663.0, 71.19932432432432
663.7999877929688, 39.7804054054054
673.7999877929688, 45.439189189189186
674.2999877929688, 39.273648648648646
675.9000244140625, 38.513513513513516
677.2999877929688, 6.418918918918918
684.4000244140625, 72.55067567567568
686.0, 28.29391891891892
695.4000244140625, 43.58108108108108
696.2000122070312, 38.68243243243243
697.0, 38.85135135135135
697.7999877929688, 35.979729729729726
706.0, 66.04729729729729
706.9000244140625, 32.263513513513516
707.7000122070312, 31.25
708.5, 26.18243243243243
710.0999755859375, 6.418918918918918
716.7999877929688, 33.61486486486486
718.5, 38.26013513513514
719.2000122070312, 32.854729729729726
727.5999755859375, 66.55405405405405
728.9000244140625, 30.574324324324323
731.7999877929688, 1.1824324324324325
738.2000122070312, 26.60472972972973
739.9000244140625, 40.70945945945946
749.0, 50.4222972972973
749.9000244140625, 29.138513513513512
751.0999755859375, 28.04054054054054
751.7999877929688, 25.25337837837838
752.7000122070312, 15.625
753.7000122070312, 5.996621621621621
759.9000244140625, 42.98986486486486
761.0999755859375, 33.277027027027025
762.0, 31.41891891891892
763.2999877929688, 21.70608108108108
763.5999755859375, 21.368243243243242
770.5999755859375, 53.63175675675676
771.5999755859375, 22.21283783783784
772.7000122070312, 25.16891891891892
773.4000244140625, 19.341216216216214
773.9000244140625, 21.62162162162162
774.7999877929688, 7.939189189189189
781.5, 26.18243243243243
782.4000244140625, 26.77364864864865
783.0, 28.716216216216214
783.7999877929688, 31.925675675675674
784.2999877929688, 30.320945945945944
785.2000122070312, 18.91891891891892
792.0, 36.486486486486484
793.7999877929688, 17.06081081081081
794.7000122070312, 19.425675675675674
795.5999755859375, 21.62162162162162
796.7999877929688, 10.219594594594595
803.0999755859375, 31.672297297297295
804.5, 23.47972972972973
805.0, 22.12837837837838
805.5, 21.283783783783782
806.2999877929688, 17.652027027027028
807.5, 7.85472972972973
808.2000122070312, 2.956081081081081
809.0999755859375, 0.6756756756756757
813.7000122070312, 41.4695945945946
815.2999877929688, 15.033783783783784
816.0, 19.08783783783784
816.5, 18.41216216216216
817.4000244140625, 14.02027027027027
818.5, 14.611486486486486
824.2999877929688, 19.1722972972973
825.4000244140625, 14.02027027027027
826.7000122070312, 25.33783783783784
827.4000244140625, 30.489864864864863
828.5, 19.1722972972973
829.5999755859375, 4.8141891891891895
835.0999755859375, 40.79391891891892
836.0999755859375, 6.081081081081081
839.0999755859375, 24.91554054054054
840.0, 14.695945945945946
846.0999755859375, 13.429054054054054
846.7999877929688, 26.26689189189189
848.0, 25.16891891891892
848.9000244140625, 20.35472972972973
849.5, 14.949324324324325
850.5, 7.939189189189189
851.2000122070312, 5.320945945945946
852.2999877929688, 0.08445945945945946
856.7000122070312, 29.64527027027027
857.7000122070312, 6.925675675675675
859.0, 14.611486486486486
859.7000122070312, 14.949324324324325
861.5999755859375, 7.1790540540540535
864.0999755859375, 1.6047297297297296
867.5999755859375, 30.574324324324323
868.7000122070312, 12.162162162162161
870.2999877929688, 20.43918918918919
871.0999755859375, 16.131756756756758
871.5, 14.695945945945946
872.7999877929688, 10.641891891891891
878.2000122070312, 40.03378378378378
879.0999755859375, 3.9695945945945943
880.5999755859375, 2.7871621621621623
882.5999755859375, 15.202702702702702
883.0999755859375, 18.158783783783782
884.2999877929688, 8.192567567567567
885.4000244140625, 5.405405405405405
889.2000122070312, 31.50337837837838
890.0, 11.993243243243242
891.2999877929688, 10.472972972972972
892.4000244140625, 9.54391891891892
893.7000122070312, 13.766891891891891
894.5999755859375, 11.570945945945946
895.5, 4.64527027027027
896.5999755859375, 0.5912162162162162
899.7000122070312, 30.574324324324323
902.5, 9.121621621621621
903.4000244140625, 10.89527027027027
904.2000122070312, 14.611486486486486
904.5, 15.033783783783784
905.2999877929688, 3.4628378378378377
906.7999877929688, 3.209459459459459
907.5, 1.2668918918918919
910.7000122070312, 3.8006756756756754
912.0999755859375, 3.209459459459459
913.2999877929688, 10.135135135135135
914.4000244140625, 16.385135135135133
915.2000122070312, 10.388513513513514
915.5999755859375, 10.557432432432432
916.2000122070312, 9.712837837837837
921.2000122070312, 35.89527027027027
925.2999877929688, 3.209459459459459
926.2999877929688, 5.0675675675675675
927.4000244140625, 9.29054054054054
928.2000122070312, 17.736486486486488
928.7999877929688, 11.570945945945946
932.0999755859375, 19.679054054054053
933.5, 5.236486486486486
934.5, 5.743243243243243
935.2000122070312, 4.983108108108108
935.7000122070312, 2.449324324324324
937.5, 9.29054054054054
938.4000244140625, 12.162162162162161
939.5999755859375, 14.10472972972973
942.7999877929688, 32.0945945945946
946.5999755859375, 0.5067567567567568
947.5999755859375, 13.682432432432432
948.5, 7.094594594594595
949.2000122070312, 10.557432432432432
950.2000122070312, 9.45945945945946
951.4000244140625, 5.489864864864865
953.5999755859375, 4.8141891891891895
957.9000244140625, 11.402027027027026
959.2000122070312, 13.682432432432432
960.0, 11.486486486486486
960.7000122070312, 8.277027027027026
961.0, 7.939189189189189
964.2999877929688, 35.472972972972975
969.0999755859375, 1.0135135135135136
970.4000244140625, 9.712837837837837
971.5999755859375, 21.95945945945946
975.0999755859375, 20.18581081081081
981.0999755859375, 8.952702702702702
983.0999755859375, 19.594594594594593
985.7999877929688, 32.77027027027027
991.7999877929688, 6.16554054054054
993.0, 18.91891891891892
994.7999877929688, 5.0675675675675675
996.5999755859375, 24.324324324324323
1002.0999755859375, 6.081081081081081
1003.2000122070312, 12.922297297297296
1004.2000122070312, 20.27027027027027
1004.7000122070312, 19.847972972972972
1006.7000122070312, 8.868243243243244
1007.4000244140625, 50.16891891891892
1014.4000244140625, 27.533783783783782
1015.0, 34.45945945945946
1016.0, 16.554054054054053
1018.2999877929688, 20.945945945945944
1024.5, 5.658783783783783
1025.5999755859375, 22.381756756756758
1026.5, 27.87162162162162
1028.9000244140625, 48.986486486486484
1036.4000244140625, 19.847972972972972
1037.5, 19.341216216216214
1038.199951171875, 14.18918918918919
1039.800048828125, 32.179054054054056
1048.0999755859375, 28.125
1050.4000244140625, 55.48986486486486
1057.9000244140625, 32.0945945945946
1059.0, 27.027027027027025
1061.4000244140625, 34.29054054054054
1069.300048828125, 31.58783783783784
1069.9000244140625, 29.30743243243243
1071.9000244140625, 65.96283783783784
1079.0999755859375, 15.371621621621621
1079.5, 14.864864864864865
1080.300048828125, 21.030405405405403
1080.699951171875, 20.861486486486484
1081.199951171875, 21.368243243243242
1082.699951171875, 49.070945945945944
1090.9000244140625, 26.52027027027027
1091.5, 22.635135135135133
1092.800048828125, 34.96621621621622
1093.5, 67.14527027027027
1101.300048828125, 27.95608108108108
1102.199951171875, 33.61486486486486
1102.9000244140625, 26.68918918918919
1104.300048828125, 60.72635135135135
1105.199951171875, 11.655405405405405
1112.5, 30.320945945945944
1113.0999755859375, 35.13513513513514
1115.0999755859375, 74.07094594594595
1115.9000244140625, 12.58445945945946
1123.5999755859375, 29.054054054054053
1125.9000244140625, 54.814189189189186
1134.4000244140625, 36.82432432432432
1135.699951171875, 36.402027027027025
1136.5, 60.30405405405405
1137.0999755859375, 26.94256756756757
1144.5999755859375, 20.52364864864865
1145.5, 33.86824324324324
1147.4000244140625, 90.28716216216216
1148.4000244140625, 27.618243243243242
1156.0999755859375, 28.5472972972973
1157.0, 27.364864864864863
1158.0999755859375, 93.91891891891892
1158.9000244140625, 31.16554054054054
1165.9000244140625, 20.01689189189189
1166.9000244140625, 30.06756756756757
1169.0999755859375, 85.30405405405405
1169.800048828125, 38.85135135135135
1177.300048828125, 31.841216216216214
1178.9000244140625, 43.75
1179.699951171875, 90.87837837837837
1188.5999755859375, 27.87162162162162
1190.4000244140625, 78.04054054054053
1199.199951171875, 24.408783783783782
1201.0999755859375, 96.62162162162161
1208.800048828125, 3.8006756756756754
1209.9000244140625, 20.43918918918919
1212.0, 70.35472972972973
1213.0999755859375, 46.70608108108108
1220.4000244140625, 18.41216216216216
1221.0999755859375, 19.341216216216214
1222.0999755859375, 46.11486486486486
1222.800048828125, 93.83445945945945
1233.4000244140625, 76.6891891891892
1242.4000244140625, 14.18918918918919
1244.199951171875, 100.0
1253.300048828125, 17.736486486486488
1255.0, 72.97297297297297
1255.800048828125, 58.445945945945944
1264.0, 11.06418918918919
1265.800048828125, 96.95945945945945
1267.4000244140625, 39.7804054054054
1276.800048828125, 71.11486486486486
1277.5999755859375, 62.9222972972973
1287.300048828125, 86.99324324324324
1296.199951171875, 0.8445945945945945
1298.199951171875, 74.07094594594595
1299.0, 57.0945945945946
1299.4000244140625, 54.22297297297297
1308.9000244140625, 94.42567567567568
1319.5, 64.69594594594595
1320.5, 63.51351351351351
1321.5, 56.6722972972973
1330.4000244140625, 88.17567567567568
1331.300048828125, 49.49324324324324
1332.0999755859375, 49.91554054054054
1341.300048828125, 78.80067567567568
1342.5, 55.74324324324324
1343.0999755859375, 53.04054054054054
1352.0, 76.94256756756756
1353.0, 60.38851351351351
1353.800048828125, 48.902027027027025
1362.5999755859375, 58.61486486486486
1363.5, 55.57432432432432
1364.0999755859375, 56.84121621621622
1373.4000244140625, 67.73648648648648
1375.0999755859375, 46.875
1376.5, 33.5304054054054
1384.4000244140625, 48.648648648648646
1385.699951171875, 52.95608108108108
1386.800048828125, 43.75
1395.0, 66.63851351351352
1395.800048828125, 47.55067567567568
1396.800048828125, 44.679054054054056
1397.0999755859375, 44.84797297297297
1405.699951171875, 40.70945945945946
1407.300048828125, 54.898648648648646
1416.5, 64.94932432432432
1417.699951171875, 39.358108108108105
1418.300048828125, 43.58108108108108
1419.0999755859375, 41.0472972972973
1421.199951171875, 4.983108108108108
1427.800048828125, 42.314189189189186
1428.5, 44.5945945945946
1429.0999755859375, 45.354729729729726
1429.5999755859375, 44.84797297297297
1431.300048828125, 26.35135135135135
1438.0999755859375, 59.29054054054054
1439.0, 44.51013513513514
1439.5, 44.763513513513516
1440.0999755859375, 40.11824324324324
1448.800048828125, 31.16554054054054
1449.9000244140625, 37.75337837837838
##PAGE=T= 0.0133
##XYDATA=(XY..XY)
100.5999984741211, 10.694919250265237
102.30000305175781, 4.084639867971236
103.69999694824219, 6.984557349994105
104.9000015258789, 3.0310621242484967
105.5, 7.660910055404927
106.19999694824219, 8.31515973122716
107.0999984741211, 2.6287869857361783
108.5999984741211, 4.293881881409878
109.4000015258789, 5.634799009784274
110.69999694824219, 2.988329600377225
111.30000305175781, 3.2638807025816337
112.5, 6.137274549098196
113.19999694824219, 3.3125073676765293
114.30000305175781, 6.165271719910409
115.19999694824219, 3.3685017093009546
116.5, 10.980785099610987
118.0999984741211, 100.0
119.19999694824219, 6.720794530236945
120.5999984741211, 2.2456678062006366
122.5999984741211, 11.527466698102087
124.30000305175781, 4.35134975834021
125.5, 1.9097017564540846
126.69999694824219, 7.460509253801721
127.4000015258789, 5.651007898149239
128.1999969482422, 6.940351290816928
129.3000030517578, 10.438524107037605
130.3000030517578, 5.176529529647531
132.0, 10.12908169279736
133.39999389648438, 6.9624543204055165
134.1999969482422, 6.418719792526229
135.60000610351562, 2.8498172816220677
136.39999389648438, 5.285571142284569
137.39999389648438, 10.463574207238006
138.0, 18.420664859130024
140.1999969482422, 26.912648827065897
141.6999969482422, 7.998349640457385
142.1999969482422, 9.222857479665212
143.5, 1.000530472710126
144.6999969482422, 3.532064128256513
145.6999969482422, 3.5409053400919484
146.5, 3.050218083225274
148.5, 1.6253094424142402
149.8000030517578, 34.351055051279026
150.39999389648438, 36.47294589178357
151.60000610351562, 15.691677472592243
152.3000030517578, 12.790286455263468
153.5, 1.8419191323824118
154.0, 1.4691146999882116
154.60000610351562, 1.315867028173995
156.1999969482422, 9.026877283979724
157.1999969482422, 5.771837793233526
158.1999969482422, 10.637451373334905
159.0, 7.7817399504892135
160.1999969482422, 1.5560532830366616
161.0, 2.7451962749027468
162.1999969482422, 1.065366026169987
163.39999389648438, 0.8340209831427561
164.1999969482422, 1.130201579629848
165.5, 1.2583991512436639
166.5, 1.859601556053283
167.39999389648438, 1.7004597430154427
168.0, 1.5368973240598844
168.5, 1.6886714605681952
169.8000030517578, 3.4348107980667217
170.60000610351562, 1.6149946952728986
172.3000030517578, 1.528056112224449
173.10000610351562, 1.4558528822350583
174.5, 0.5393139219615702
176.6999969482422, 2.216197100082518
178.5, 0.2740775668985029
179.5, 0.8281268419191323
180.1999969482422, 1.2495579394082281
181.39999389648438, 2.188199929270305
182.1999969482422, 0.7853943180478604
182.89999389648438, 1.3040787457267475
184.3000030517578, 2.21914417069433
186.0, 0.7559236119297418
187.1999969482422, 1.0108452198514677
188.0, 0.7411882588706825
189.3000030517578, 1.2274549098196392
190.10000610351562, 1.1139926912648828
192.1999969482422, 1.1832488506424614
192.89999389648438, 0.8428621949781917
193.60000610351562, 1.463220558764588
195.0, 2.4608039608629024
196.39999389648438, 0.668985028881292
197.5, 0.584993516444654
199.5, 2.776140516326771
200.6999969482422, 2.173464576211246
202.60000610351562, 2.484380525757397
203.60000610351562, 0.8281268419191323
204.60000610351562, 1.0358953200518684
207.3000030517578, 1.7196157019922198
208.5, 2.070317104797831
209.5, 2.80561122244489
211.39999389648438, 2.033478722150183
212.3000030517578, 1.9774843805257574
213.3000030517578, 0.7426617941765885
214.3000030517578, 2.2471413415065427
214.6999969482422, 1.7638217611693976
216.6999969482422, 3.0590592950607096
217.39999389648438, 3.5188023105033595
218.89999389648438, 2.2662973004833193
220.5, 2.0673700341860193
221.5, 1.939172462572203
223.5, 2.8571849581515973
224.5, 1.463220558764588
225.39999389648438, 1.1375692561593775
226.0, 1.2009312743133325
226.60000610351562, 2.242720735588825
228.60000610351562, 3.112106566073323
229.5, 0.8089708829423553
230.39999389648438, 1.731403984439467
230.89999389648438, 1.9701167039962277
232.1999969482422, 1.3026052104208417
233.0, 1.167039962277496
233.6999969482422, 0.7824472474360485
234.8000030517578, 1.7255098432158433
236.3000030517578, 1.12578097371213
237.39999389648438, 2.967700106094542
238.39999389648438, 1.1817753153365556
239.5, 1.41901449958741
240.8000030517578, 2.048214075209242
241.39999389648438, 2.2176706353884237
242.1999969482422, 0.7058234115289402
243.0, 2.3046092184368736
244.39999389648438, 2.6847813273606036
245.1999969482422, 2.170517505599434
246.10000610351562, 0.3197571613815867
246.5, 0.38164564422963576
247.39999389648438, 0.6999292703053165
248.5, 1.3644936932688907
249.89999389648438, 1.108098550041259
250.60000610351562, 1.5531062124248496
251.3000030517578, 1.6989862077095368
252.5, 2.032005186844277
254.1999969482422, 2.3267122480254625
255.0, 1.3306023812330543
256.70001220703125, 4.996758222327007
257.29998779296875, 4.911293174584463
258.3999938964844, 2.3768124484262643
259.3999938964844, 2.699516680419663
261.29998779296875, 2.3694447718967346
262.79998779296875, 2.2721914417069433
263.1000061035156, 2.2324059884474834
264.70001220703125, 1.836024991158788
265.0, 1.7652952964753035
266.1000061035156, 1.4116468230578805
267.5, 1.1316751149357538
268.5, 1.0830484498408581
269.70001220703125, 0.8767535070140281
270.5, 0.9062242131321466
271.5, 2.3886007308735118
272.1000061035156, 1.6326771189437699
273.29998779296875, 1.2362961216550747
274.20001220703125, 2.2441942708947304
275.0, 0.3020747377107155
276.20001220703125, 1.9038076152304608
277.0, 1.6474124720028291
277.5, 1.3497583402098314
278.5, 1.482376517741365
279.3999938964844, 0.7662383590710833
280.79998779296875, 1.775610043616645
281.8999938964844, 2.681834256748792
282.5, 2.479959919839679
283.3999938964844, 2.5565837557467876
285.20001220703125, 2.535954261464105
285.70001220703125, 0.9121183543557704
286.70001220703125, 0.7072969468348461
287.29998779296875, 0.7176116939761876
288.29998779296875, 0.6630908876576682
289.79998779296875, 0.9121183543557704
291.0, 1.337970057762584
292.20001220703125, 1.5206884356949193
292.8999938964844, 1.4381704585641872
293.5, 1.861075091359189
294.0, 2.1425203347872213
295.1000061035156, 0.8767535070140281
295.8999938964844, 1.5162678297772014
297.0, 2.0261110456206533
298.6000061035156, 1.6886714605681952
299.29998779296875, 1.2141930920664858
300.29998779296875, 2.9146528350819287
301.3999938964844, 2.929388188140988
301.8999938964844, 3.4171283743958503
304.1000061035156, 2.468171637392432
305.20001220703125, 0.9636920900624779
306.3999938964844, 1.9789579158316633
307.3999938964844, 1.2775551102204408
308.1000061035156, 1.3556524814334552
309.1000061035156, 2.3517623482258636
310.1000061035156, 1.402805611222445
311.0, 0.6380407874572674
312.0, 4.127372391842509
312.8999938964844, 3.5865849345750322
314.1000061035156, 1.610574089355181
315.20001220703125, 0.7677118943769893
316.29998779296875, 1.3733349051043262
318.0, 1.6871979252622893
319.1000061035156, 1.6709890368973241
320.8999938964844, 0.8944359306848992
322.1000061035156, 1.586997524460686
322.8999938964844, 2.640575268183426
323.29998779296875, 2.586054461864906
323.79998779296875, 2.4328067900506896
324.3999938964844, 3.9372863373806437
326.0, 0.8885417894612755
327.70001220703125, 5.381350937168454
329.20001220703125, 2.0938936696923256
330.29998779296875, 1.1744076388070257
331.20001220703125, 1.6120476246610869
332.3999938964844, 1.25250501002004
333.6000061035156, 2.1631498290699045
334.6000061035156, 0.648355534598609
336.70001220703125, 2.229458917835671
338.1000061035156, 0.5938347282800895
338.8999938964844, 0.6291995756218319
340.6000061035156, 1.5531062124248496
341.6000061035156, 1.797713073205234
343.1000061035156, 1.1832488506424614
344.5, 0.3801721089237298
345.6000061035156, 1.084521985146764
346.1000061035156, 1.1405163267711895
347.29998779296875, 0.45826948013674407
348.5, 0.6424613933749852
349.6000061035156, 1.0137922904632795
350.70001220703125, 2.3355534598608982
351.5, 1.3070258163385595
352.5, 1.544265000589414
354.6000061035156, 1.171460568195214
355.0, 1.208298950842862
356.0, 1.6680419662855122
356.5, 1.3040787457267475
357.20001220703125, 3.0369562654721207
358.5, 0.7780266415183308
360.79998779296875, 0.502475539313922
362.0, 0.49805493339620416
362.70001220703125, 0.3241777672993045
363.6000061035156, 1.0712601673936106
364.3999938964844, 1.4543793469291524
365.1000061035156, 1.0064246139337498
365.79998779296875, 0.3285983732170223
367.0, 1.4573264175409644
368.3999938964844, 1.2863963220558765
369.1000061035156, 1.9155958976777083
370.1000061035156, 2.0953672049982317
372.1000061035156, 1.146410467994813
373.0, 1.3350229871507722
374.0, 0.6321466462336437
374.6000061035156, 1.0123187551573736
375.5, 0.6542496758222327
376.1000061035156, 0.4287987740186255
377.70001220703125, 2.507957090651892
378.79998779296875, 1.000530472710126
380.20001220703125, 0.8914888600730874
381.8999938964844, 0.5776258399151244
382.79998779296875, 1.1036779441235411
383.29998779296875, 1.5162678297772014
384.29998779296875, 1.5840504538488742
386.5, 1.003477543321938
387.20001220703125, 0.8325474478368502
389.0, 1.6916185311800072
389.6000061035156, 1.67246257220323
390.70001220703125, 1.109572085347165
392.6000061035156, 0.5157373570670754
393.20001220703125, 0.271130496286691
394.6000061035156, 0.8074973476364493
395.29998779296875, 1.9376989272662972
396.3999938964844, 0.5776258399151244
397.1000061035156, 0.6115171519509608
399.5, 0.1340917128374396
400.8999938964844, 11.742602852764351
402.20001220703125, 13.07909937522103
403.8999938964844, 10.173287751974538
404.5, 8.266533066132265
405.20001220703125, 3.408287162560415
406.6000061035156, 0.6115171519509608
407.29998779296875, 0.62625250501002
408.70001220703125, 1.6474124720028291
410.0, 1.0108452198514677
410.8999938964844, 0.2888129199575622
411.20001220703125, 0.30354827301662146
412.20001220703125, 0.5555228103265354
414.6000061035156, 0.5864670517505599
415.29998779296875, 1.0742072380054226
416.20001220703125, 1.041789461275492
417.5, 0.7264529058116233
418.70001220703125, 1.1832488506424614
419.5, 1.5398443946716962
420.70001220703125, 1.8537074148296593
422.20001220703125, 1.1626193563597784
423.29998779296875, 1.5162678297772014
424.29998779296875, 2.929388188140988
425.0, 0.9695862312861016
426.6000061035156, 0.6380407874572674
427.6000061035156, 1.485323588353177
428.70001220703125, 0.6601438170458565
429.79998779296875, 3.720676647412472
430.8999938964844, 1.12578097371213
431.8999938964844, 2.2279853825297655
434.0, 1.0152658257691853
434.79998779296875, 0.6321466462336437
437.0, 1.9568548862430744
439.70001220703125, 2.006955086643876
440.6000061035156, 1.0476836024991159
441.1000061035156, 0.9931627961805964
441.8999938964844, 0.502475539313922
443.20001220703125, 0.3197571613815867
445.3999938964844, 1.4337498526464694
446.1000061035156, 1.0108452198514677
447.1000061035156, 3.215254037486738
449.6000061035156, 0.37722503831191795
450.5, 0.8413886596722857
451.6000061035156, 0.439113521159967
453.1000061035156, 1.6606742897559825
454.3999938964844, 2.1999882117175527
455.20001220703125, 0.6498290699045149
455.79998779296875, 0.670458564187198
457.0, 0.9740068372038194
458.5, 0.7131910880584699
459.3999938964844, 0.7765531062124248
460.0, 0.44206059177177887
461.1000061035156, 1.4558528822350583
462.20001220703125, 0.9224331014971119
463.1000061035156, 0.41111635034775434
464.79998779296875, 0.564364022161971
465.29998779296875, 0.543734527879288
466.8999938964844, 1.002004008016032
468.70001220703125, 0.5673110927737829
470.29998779296875, 1.7697159023930213
471.1000061035156, 0.2755511022044088
472.3999938964844, 0.7264529058116233
472.8999938964844, 0.7691854296828952
474.1000061035156, 0.02799717081221266
475.20001220703125, 0.34775433219379936
476.3999938964844, 0.9091712837439585
478.5, 0.14145938936696922
481.1000061035156, 0.8944359306848992
481.70001220703125, 0.45384887421902625
483.0, 0.3462807968878934
483.70001220703125, 0.6115171519509608
484.6000061035156, 1.1596722857479664
485.5, 0.37722503831191795
487.1000061035156, 0.8708593657904043
487.79998779296875, 0.3521749381115171
488.8999938964844, 1.1552516798302488
490.1000061035156, 0.521631498290699
491.0, 0.04420605917717788
492.3999938964844, 1.5840504538488742
493.5, 0.1650359542614641
494.79998779296875, 0.9062242131321466
495.5, 0.8885417894612755
496.3999938964844, 0.33301897913474005
497.70001220703125, 0.3742779677001061
498.5, 0.1797713073205234
499.20001220703125, 0.5717316986915006
500.1000061035156, 0.5113167511493575
500.5, 0.3845927148414476
501.29998779296875, 0.31091594954615115
502.70001220703125, 0.1591418130378404
503.70001220703125, 0.6851939172462572
504.70001220703125, 0.40080160320641284
505.5, 0.711717552752564
506.5, 0.5378403866556642
508.1000061035156, 0.05452080631851939
509.20001220703125, 0.09725333018979135
510.5, 0.8281268419191323
512.0999755859375, 0.3698573617823883
512.9000244140625, 0.3094424142402452
514.5, 0.3094424142402452
515.2999877929688, 0.6321466462336437
515.7999877929688, 0.45090180360721444
516.5, 0.019155958976777084
516.9000244140625, 0.02210302958858894
518.2000122070312, 1.2790286455263469
519.0999755859375, 0.2755511022044088
520.0999755859375, 0.7190852292820936
521.2000122070312, 0.4450076623835907
522.0, 0.6645644229635742
522.7999877929688, 0.2401862548626665
524.0, 0.3786985736178239
525.2000122070312, 0.45090180360721444
525.9000244140625, 0.5334197807379465
528.2000122070312, 0.4229046327950018
529.7999877929688, 1.796239537899328
532.0999755859375, 0.4759519038076152
533.5999755859375, 1.7476128728044324
536.5, 0.12082989508428622
537.2999877929688, 0.002947070611811859
538.7999877929688, 1.6621478250618884
540.4000244140625, 0.3492278674997053
541.0, 0.34775433219379936
543.0999755859375, 0.04273252387127195
544.4000244140625, 0.15177413650831073
545.4000244140625, 0.10609454202522692
546.4000244140625, 0.019155958976777084
548.2999877929688, 0.2549216079217258
549.0, 0.5511022044088176
551.2000122070312, 1.3556524814334552
552.4000244140625, 0.2888129199575622
553.9000244140625, 0.15766827773193445
555.9000244140625, 0.5172108923729812
558.0999755859375, 1.105151479429447
558.9000244140625, 0.07809737121301426
560.0, 0.4361664505481551
560.5999755859375, 0.229871507721325
561.5, 0.10020040080160321
562.0999755859375, 0.2048214075209242
563.4000244140625, 0.4700577625839915
564.0999755859375, 0.35364847341742306
564.9000244140625, 0.38753978545325946
566.0, 0.22103029588588943
566.7999877929688, 0.4626900860544619
568.9000244140625, 0.40080160320641284
569.4000244140625, 0.5039490746198279
570.2999877929688, 0.27702463751031475
570.9000244140625, 0.3890133207591654
571.2999877929688, 0.375751503006012
572.4000244140625, 0.5201579629847931
573.2999877929688, 0.15177413650831073
574.0, 0.025050100200400802
574.5, 0.050100200400801605
575.5999755859375, 0.5039490746198279
576.5, 0.16650948956737002
577.5999755859375, 0.1591418130378404
579.0999755859375, 0.5452080631851939
580.2000122070312, 0.09872686549569727
582.2000122070312, 0.46416362136036776
582.9000244140625, 0.26670989036897325
583.5999755859375, 0.004420605917717788
585.5, 1.1832488506424614
586.2000122070312, 0.42143109748909585
587.7999877929688, 0.375751503006012
589.2000122070312, 0.3860662501473535
590.4000244140625, 0.04273252387127195
591.4000244140625, 0.15030060120240482
592.5999755859375, 0.40080160320641284
594.0, 0.209242013438642
596.2000122070312, 1.0683130967817989
598.5, 0.2814452434280325
599.5999755859375, 0.46416362136036776
600.5, 0.1797713073205234
601.2000122070312, 0.3094424142402452
602.5, 0.3786985736178239
603.0, 0.38753978545325946
604.2000122070312, 0.3595426146410468
606.4000244140625, 0.1694565601791819
608.2000122070312, 0.7058234115289402
609.2999877929688, 0.11640928916656842
610.0, 0.15324767181421667
612.7000122070312, 0.16650948956737002
614.2999877929688, 0.34038665566426973
615.5999755859375, 0.1650359542614641
617.0, 0.43174584463043736
617.7999877929688, 0.2681834256748792
619.0999755859375, 0.061888482848049035
621.0999755859375, 0.8428621949781917
621.7999877929688, 0.5481551337970058
623.7999877929688, 0.4346929152422492
624.7999877929688, 0.898856536602617
625.4000244140625, 0.7411882588706825
626.0999755859375, 0.30354827301662146
627.0999755859375, 0.0854650477425439
627.5, 0.09283272427207356
628.2999877929688, 0.035364847341742306
630.2000122070312, 0.5319462454320405
632.7000122070312, 0.9489567370034185
633.2999877929688, 0.8148650241659791
634.0, 0.5186844276788872
635.0999755859375, 0.02210302958858894
636.0999755859375, 0.11198868324885064
637.0999755859375, 1.4661676293763999
637.9000244140625, 0.08104444182482612
639.0999755859375, 0.5186844276788872
640.0, 0.019155958976777084
640.9000244140625, 0.051573735706707535
641.9000244140625, 0.6969821996935046
644.0, 0.5378403866556642
645.7999877929688, 0.1606153483437463
647.0999755859375, 0.31238948485205703
648.7000122070312, 0.04273252387127195
650.4000244140625, 0.5068961452316397
651.2000122070312, 0.03241777672993045
651.7999877929688, 0.07809737121301426
653.2000122070312, 0.6955086643875987
653.7999877929688, 0.14145938936696922
654.9000244140625, 0.11935635977838029
656.4000244140625, 0.09283272427207356
658.2000122070312, 0.4788989744194271
659.4000244140625, 0.6630908876576682
661.0, 1.130201579629848
662.4000244140625, 0.5186844276788872
663.4000244140625, 0.5805729105269363
664.2999877929688, 0.008841211835435576
665.7999877929688, 0.3153365554638689
666.9000244140625, 0.16208888364965224
668.5999755859375, 0.9961098667924083
669.5999755859375, 0.0397854532594601
671.2999877929688, 0.3595426146410468
672.2000122070312, 0.5348933160438524
674.0999755859375, 0.2342921136390428
674.9000244140625, 0.3845927148414476
675.5, 0.6070965460332429
677.4000244140625, 0.22692443710951313
678.0999755859375, 0.36248968525285863
678.7000122070312, 0.19745373099139454
682.7000122070312, 0.9356949192502653
683.5, 0.41111635034775434
685.0999755859375, 0.22545090180360722
687.5, 0.8222327006955087
688.7999877929688, 0.35364847341742306
689.5, 0.16650948956737002
691.4000244140625, 0.4892137215607686
692.5, 0.3683838264764824
693.2999877929688, 0.07809737121301426
694.7000122070312, 0.05304727101261346
695.2999877929688, 0.10167393610750913
696.9000244140625, 1.1213603677944124
697.7999877929688, 0.32712483791111635
699.2999877929688, 0.42437816810090767
700.0999755859375, 0.08251797713073206
700.7000122070312, 0.06925615937757869
702.2999877929688, 0.7072969468348461
703.5999755859375, 0.1709300954850878
704.7000122070312, 0.15030060120240482
705.5999755859375, 0.8340209831427561
706.4000244140625, 0.047153129788989744
707.7999877929688, 0.6719320994931038
709.5999755859375, 0.45090180360721444
712.0, 0.35659554402923493
712.9000244140625, 0.011788282447247436
714.2999877929688, 1.0535777437227396
716.4000244140625, 0.8237062360014146
717.2999877929688, 0.02947070611811859
719.0999755859375, 0.35659554402923493
720.0, 0.051573735706707535
720.7999877929688, 0.06336201815395497
722.7999877929688, 0.45826948013674407
724.0999755859375, 0.0648355534598609
725.2999877929688, 0.43763998585406105
726.2000122070312, 0.09430625957797949
727.5, 0.048626665094895674
728.2999877929688, 0.06778262407167275
729.5, 0.13114464222562772
731.0999755859375, 0.18271837793233525
732.0, 0.05894141223623718
734.7000122070312, 0.23281857833313685
736.0999755859375, 0.4494282683013085
737.0999755859375, 0.07367676529529647
738.0, 0.08251797713073206
739.5, 0.2519745373099139
740.5999755859375, 0.23134504302723094
741.7000122070312, 0.2814452434280325
742.4000244140625, 0.32270423199339854
744.2999877929688, 0.12819757161381587
745.4000244140625, 0.4936343274784864
746.2999877929688, 0.025050100200400802
748.2000122070312, 0.7809737121301427
749.7000122070312, 0.250501002004008
750.5999755859375, 0.9681126959801957
752.0999755859375, 0.05452080631851939
753.2000122070312, 0.0
754.4000244140625, 0.02799717081221266
755.4000244140625, 0.7559236119297418
756.0999755859375, 0.7382411882588706
758.0, 1.1803017800306495
759.0, 0.16208888364965224
760.0999755859375, 0.04567959448308381
762.0999755859375, 0.878227042319934
763.2000122070312, 0.05304727101261346
764.5999755859375, 0.3993280679005069
765.7999877929688, 0.3212306966874926
768.2999877929688, 0.2578686785335377
769.9000244140625, 0.7043498762230342
771.7000122070312, 0.6174112931745844
772.7999877929688, 0.47742543911352114
775.0999755859375, 0.5967817988919014
775.9000244140625, 0.07072969468348461
776.5, 0.07515030060120241
777.7000122070312, 0.22250383119179534
779.0, 0.02947070611811859
780.2000122070312, 0.035364847341742306
781.5999755859375, 0.19745373099139454
782.0, 0.1591418130378404
783.0, 0.07515030060120241
784.0, 0.20629494282683014
784.5999755859375, 0.08104444182482612
786.4000244140625, 0.19745373099139454
787.7999877929688, 0.37722503831191795
789.9000244140625, 0.2784981728162207
790.7999877929688, 0.4656371566662737
791.7000122070312, 0.6748791701049157
792.5999755859375, 0.02210302958858894
793.5, 0.047153129788989744
794.2999877929688, 0.09430625957797949
795.2999877929688, 0.04567959448308381
796.7999877929688, 0.30649534362843334
798.0, 0.014735353059059295
799.2000122070312, 0.1606153483437463
800.9000244140625, 0.10609454202522692
801.9000244140625, 0.0898856536602617
802.7000122070312, 0.06925615937757869
803.7000122070312, 0.02799717081221266
805.5, 1.024107037604621
806.5, 0.3212306966874926
807.2000122070312, 0.08104444182482612
807.7000122070312, 0.09577979488388541
808.7999877929688, 0.047153129788989744
809.9000244140625, 0.4523753389131204
811.0999755859375, 0.502475539313922
811.5, 0.45679594483083813
813.2999877929688, 1.7873983260638924
815.5, 0.9091712837439585
816.4000244140625, 0.2696569609807851
817.0999755859375, 0.04420605917717788
818.5, 0.8251797713073206
819.5, 0.8399151243663798
820.2999877929688, 0.08841211835435576
822.4000244140625, 0.31681009076977484
823.2999877929688, 0.18124484262642931
824.5, 0.15766827773193445
826.2999877929688, 0.3698573617823883
827.5, 0.08251797713073206
828.2000122070312, 0.04273252387127195
828.7999877929688, 0.12082989508428622
831.0, 0.036838382647648237
831.7000122070312, 0.050100200400801605
833.0, 0.23134504302723094
835.0, 0.02652363550630673
835.9000244140625, 0.0
836.5, 0.04125898856536603
837.0, 0.0795709065189202
837.5999755859375, 0.11640928916656842
838.4000244140625, 0.05599434162442532
839.2000122070312, 0.014735353059059295
840.0999755859375, 0.010314747141341507
840.9000244140625, 0.036838382647648237
843.2000122070312, 0.10609454202522692
843.9000244140625, 0.09725333018979135
844.5999755859375, 0.09872686549569727
845.5, 0.06925615937757869
846.2000122070312, 0.09725333018979135
847.2999877929688, 0.0014735353059059295
849.2999877929688, 0.1900860544618649
851.5, 0.9356949192502653
852.2000122070312, 0.09283272427207356
854.0, 0.050100200400801605
856.5999755859375, 1.022633502298715
857.4000244140625, 0.06778262407167275
858.5, 0.0795709065189202
859.2999877929688, 0.0
861.5, 0.05304727101261346
863.0999755859375, 1.0801013792290464
864.5, 0.02652363550630673
865.5999755859375, 0.04420605917717788
867.0, 0.019155958976777084
868.0, 0.5039490746198279
869.2000122070312, 0.3079688789343393
870.2999877929688, 0.9872686549569728
871.5, 0.08104444182482612
874.2999877929688, 0.011788282447247436
876.0, 0.6513026052104208
877.0, 0.06041494754214311
877.7999877929688, 0.05452080631851939
879.7000122070312, 0.37280443239420014
880.5999755859375, 0.0397854532594601
881.2000122070312, 0.06336201815395497
882.4000244140625, 0.29028645526346813
884.2000122070312, 0.6100436166450548
887.0999755859375, 1.146410467994813
888.2999877929688, 0.6719320994931038
889.0999755859375, 0.40816927973594247
889.9000244140625, 0.49805493339620416
892.7000122070312, 0.061888482848049035
893.7999877929688, 0.34333372627608155
895.0999755859375, 0.11198868324885064
896.7000122070312, 0.3492278674997053
897.2999877929688, 0.39343392667688315
899.4000244140625, 0.11198868324885064
901.0999755859375, 1.651833077920547
903.5999755859375, 0.3845927148414476
904.5999755859375, 0.5260521042084169
906.7999877929688, 0.5776258399151244
907.4000244140625, 0.44058705646587293
908.2999877929688, 0.12082989508428622
910.0, 0.5687846280796888
911.0, 0.010314747141341507
912.7999877929688, 0.3845927148414476
913.9000244140625, 0.06336201815395497
914.5, 0.07072969468348461
916.5999755859375, 0.016208888364965226
918.2999877929688, 0.08251797713073206
919.2000122070312, 0.11788282447247436
919.5, 0.1149357538606625
920.5, 0.10314747141341507
921.2000122070312, 0.033891312035836375
922.5, 0.08251797713073206
924.7999877929688, 0.09577979488388541
925.7000122070312, 0.07515030060120241
927.0999755859375, 0.03831191795355417
929.4000244140625, 0.020629494282683014
930.5999755859375, 0.0854650477425439
931.2999877929688, 0.09283272427207356
931.9000244140625, 0.04420605917717788
932.2999877929688, 0.0648355534598609
932.7999877929688, 0.05746787693033125
933.5, 0.036838382647648237
934.2999877929688, 0.002947070611811859
936.7000122070312, 0.048626665094895674
937.4000244140625, 0.06630908876576683
938.7000122070312, 0.125250501002004
939.9000244140625, 0.051573735706707535
943.4000244140625, 0.11346221855475656
944.5, 0.10609454202522692
945.4000244140625, 0.0648355534598609
948.4000244140625, 0.04273252387127195
950.4000244140625, 0.013261817753153365
952.0999755859375, 0.12230343039019215
954.5, 0.0648355534598609
955.0999755859375, 0.07072969468348461
955.9000244140625, 0.09430625957797949
957.5999755859375, 0.02799717081221266
958.0999755859375, 0.05304727101261346
959.7000122070312, 0.023576564894494872
960.7000122070312, 0.05746787693033125
961.5999755859375, 0.0854650477425439
962.0999755859375, 0.06925615937757869
963.0, 0.036838382647648237
964.2999877929688, 0.12082989508428622
964.9000244140625, 0.09577979488388541
965.9000244140625, 0.023576564894494872
967.2000122070312, 0.03241777672993045
968.2999877929688, 0.07809737121301426
969.0999755859375, 0.0648355534598609
970.4000244140625, 0.08841211835435576
974.2999877929688, 0.047153129788989744
974.9000244140625, 0.1149357538606625
976.0, 0.09283272427207356
976.7000122070312, 0.06630908876576683
977.5999755859375, 0.025050100200400802
978.7999877929688, 0.047153129788989744
979.7999877929688, 0.033891312035836375
980.2999877929688, 0.06925615937757869
981.5999755859375, 0.12819757161381587
983.2999877929688, 0.06925615937757869
985.2999877929688, 0.02799717081221266
986.5999755859375, 0.047153129788989744
987.4000244140625, 0.05452080631851939
988.0999755859375, 0.02652363550630673
989.5, 0.05894141223623718
990.5999755859375, 0.036838382647648237
992.7999877929688, 0.036838382647648237
993.9000244140625, 0.07809737121301426
994.7999877929688, 0.07367676529529647
995.2999877929688, 0.05894141223623718
998.2000122070312, 0.0014735353059059295
999.0999755859375, 0.03241777672993045
1000.0, 0.0795709065189202
1001.0, 0.10020040080160321
1001.7999877929688, 0.05452080631851939
1002.7000122070312, 0.04125898856536603
1004.9000244140625, 0.02799717081221266
1005.7999877929688, 0.08693858304844984
1006.5999755859375, 0.10609454202522692
1007.0999755859375, 0.02799717081221266
1007.5999755859375, 0.03241777672993045
1011.4000244140625, 0.08251797713073206
1011.9000244140625, 0.06630908876576683
1012.7999877929688, 0.02947070611811859
1013.5999755859375, 0.04125898856536603
1014.7000122070312, 0.061888482848049035
1015.7999877929688, 0.019155958976777084
1016.5999755859375, 0.020629494282683014
1017.2999877929688, 0.016208888364965226
1018.2000122070312, 0.07072969468348461
1018.7999877929688, 0.04567959448308381
1019.0999755859375, 0.04420605917717788
1019.5999755859375, 0.07072969468348461
1020.5999755859375, 0.061888482848049035
1021.2000122070312, 0.036838382647648237
1022.9000244140625, 0.008841211835435576
1023.9000244140625, 0.04273252387127195
1024.5, 0.03831191795355417
1025.300048828125, 0.09135918896616763
1025.9000244140625, 0.07367676529529647
1026.800048828125, 0.07072969468348461
1027.300048828125, 0.05894141223623718
1030.0, 0.051573735706707535
1030.5999755859375, 0.07515030060120241
1031.699951171875, 0.11198868324885064
1033.199951171875, 0.05894141223623718
1035.9000244140625, 0.05599434162442532
1036.9000244140625, 0.07809737121301426
1037.300048828125, 0.061888482848049035
1038.199951171875, 0.09872686549569727
1039.4000244140625, 0.05599434162442532
1040.0, 0.013261817753153365
1041.199951171875, 0.025050100200400802
1042.199951171875, 0.02947070611811859
1042.800048828125, 0.04420605917717788
1043.300048828125, 0.050100200400801605
1044.300048828125, 0.104621006719321
1045.300048828125, 0.13851231875515738
1046.699951171875, 0.05894141223623718
1048.699951171875, 0.02947070611811859
1050.0, 0.09135918896616763
1051.0999755859375, 0.035364847341742306
1051.9000244140625, 0.06925615937757869
1052.5999755859375, 0.051573735706707535
1054.300048828125, 0.016208888364965226
1055.300048828125, 0.09283272427207356
1056.0999755859375, 0.09725333018979135
1057.0999755859375, 0.1340917128374396
1057.9000244140625, 0.047153129788989744
1062.0999755859375, 0.08104444182482612
1063.0, 0.06778262407167275
1064.0, 0.047153129788989744
1064.800048828125, 0.025050100200400802
1065.800048828125, 0.004420605917717788
1067.199951171875, 0.03831191795355417
1068.5, 0.07072969468348461
1070.5999755859375, 0.08841211835435576
1071.0, 0.05304727101261346
1073.9000244140625, 0.050100200400801605
1074.699951171875, 0.11051514794294472
1075.5999755859375, 0.09430625957797949
1076.699951171875, 0.09430625957797949
1077.699951171875, 0.05746787693033125
1079.300048828125, 0.011788282447247436
1080.300048828125, 0.061888482848049035
1080.9000244140625, 0.08104444182482612
1081.4000244140625, 0.0854650477425439
1082.800048828125, 0.07072969468348461
1083.699951171875, 0.02210302958858894
1086.199951171875, 0.016208888364965226
1086.699951171875, 0.05599434162442532
1087.4000244140625, 0.07809737121301426
1088.5, 0.09135918896616763
1089.199951171875, 0.04125898856536603
1089.5999755859375, 0.033891312035836375
1092.699951171875, 0.033891312035836375
1093.5999755859375, 0.1149357538606625
1095.0, 0.04420605917717788
1095.699951171875, 0.07809737121301426
1096.5, 0.04273252387127195
1097.300048828125, 0.019155958976777084
1098.800048828125, 0.10020040080160321
1099.199951171875, 0.09135918896616763
1100.5999755859375, 0.1547212071201226
1102.0999755859375, 0.02210302958858894
1104.5, 0.036838382647648237
1105.300048828125, 0.05452080631851939
1106.0, 0.09283272427207356
1106.699951171875, 0.07662383590710833
1107.5, 0.11640928916656842
1108.0, 0.125250501002004
1111.9000244140625, 0.07072969468348461
1112.800048828125, 0.06925615937757869
1114.199951171875, 0.033891312035836375
1117.199951171875, 0.02947070611811859
1118.199951171875, 0.0795709065189202
1119.199951171875, 0.12819757161381587
1120.4000244140625, 0.030944241424024518
1121.300048828125, 0.005894141223623718
1124.4000244140625, 0.1149357538606625
1125.300048828125, 0.09135918896616763
1125.800048828125, 0.036838382647648237
1126.9000244140625, 0.013261817753153365
1127.4000244140625, 0.05304727101261346
1130.300048828125, 0.104621006719321
1130.9000244140625, 0.10904161263703878
1131.9000244140625, 0.035364847341742306
1132.800048828125, 0.07367676529529647
1133.5999755859375, 0.06778262407167275
1135.699951171875, 0.0
1136.4000244140625, 0.025050100200400802
1136.9000244140625, 0.051573735706707535
1137.4000244140625, 0.035364847341742306
1138.199951171875, 0.0795709065189202
1138.699951171875, 0.11346221855475656
1139.699951171875, 0.11640928916656842
1140.800048828125, 0.017682423670871153
1141.5, 0.017682423670871153
1142.300048828125, 0.025050100200400802
1143.199951171875, 0.0898856536602617
1143.800048828125, 0.09430625957797949
1144.699951171875, 0.09283272427207356
1145.800048828125, 0.02947070611811859
1147.5, 0.010314747141341507
1149.4000244140625, 0.13261817753153365
1150.5999755859375, 0.061888482848049035
1151.199951171875, 0.05746787693033125
1152.0, 0.035364847341742306
1155.300048828125, 0.07515030060120241
1156.199951171875, 0.03831191795355417
1156.800048828125, 0.04273252387127195
1158.0, 0.12230343039019215
1159.5, 0.04420605917717788
1160.4000244140625, 0.005894141223623718
1162.300048828125, 0.1149357538606625
1162.699951171875, 0.07367676529529647
1163.5, 0.12230343039019215
1164.800048828125, 0.04273252387127195
1167.4000244140625, 0.008841211835435576
1168.300048828125, 0.0648355534598609
1168.699951171875, 0.047153129788989744
1169.199951171875, 0.0648355534598609
1169.800048828125, 0.033891312035836375
1170.5, 0.0397854532594601
1171.0, 0.019155958976777084
1171.800048828125, 0.005894141223623718
1173.300048828125, 0.014735353059059295
1174.0999755859375, 0.030944241424024518
1174.800048828125, 0.0397854532594601
1175.699951171875, 0.07072969468348461
1176.9000244140625, 0.04567959448308381
1179.4000244140625, 0.02799717081221266
1180.800048828125, 0.08104444182482612
1181.5, 0.12377696569609807
1182.5, 0.020629494282683014
1182.9000244140625, 0.02947070611811859
1183.800048828125, 0.08104444182482612
1185.0999755859375, 0.017682423670871153
1186.199951171875, 0.0014735353059059295
1187.0999755859375, 0.048626665094895674
1188.0999755859375, 0.050100200400801605
1189.0999755859375, 0.06630908876576683
1189.800048828125, 0.13998585406106331
1192.5999755859375, 0.0648355534598609
1194.0, 0.08104444182482612
1194.9000244140625, 0.07809737121301426
1195.4000244140625, 0.02799717081221266
1196.199951171875, 0.023576564894494872
1197.0, 0.05894141223623718
1197.800048828125, 0.016208888364965226
1198.4000244140625, 0.04567959448308381
1200.0, 0.10756807733113286
1201.0, 0.035364847341742306
1201.800048828125, 0.036838382647648237
1202.5, 0.014735353059059295
1203.699951171875, 0.025050100200400802
1205.5999755859375, 0.1149357538606625
1207.0, 0.10020040080160321
1208.0999755859375, 0.06630908876576683
1210.800048828125, 0.014735353059059295
1211.4000244140625, 0.104621006719321
1212.300048828125, 0.06630908876576683
1212.5999755859375, 0.06041494754214311
1213.300048828125, 0.07072969468348461
1214.4000244140625, 0.06041494754214311
1215.0, 0.03241777672993045
1215.699951171875, 0.0
1216.4000244140625, 0.04567959448308381
1217.5999755859375, 0.09725333018979135
1219.0, 0.11198868324885064
1221.699951171875, 0.02947070611811859
1222.5, 0.03241777672993045
1223.4000244140625, 0.011788282447247436
1224.300048828125, 0.0854650477425439
1225.699951171875, 0.12230343039019215
1226.800048828125, 0.08251797713073206
1227.300048828125, 0.03831191795355417
1228.5999755859375, 0.0014735353059059295
1229.800048828125, 0.050100200400801605
1230.199951171875, 0.03831191795355417
1230.9000244140625, 0.0397854532594601
1232.0, 0.09872686549569727
1232.9000244140625, 0.06041494754214311
1233.699951171875, 0.002947070611811859
1234.5999755859375, 0.02652363550630673
1236.5, 0.09283272427207356
1238.0, 0.04567959448308381
1238.5999755859375, 0.09577979488388541
1239.699951171875, 0.019155958976777084
1240.0999755859375, 0.016208888364965226
1240.800048828125, 0.035364847341742306
1242.4000244140625, 0.06925615937757869
1243.5999755859375, 0.06041494754214311
1244.9000244140625, 0.02652363550630673
1245.9000244140625, 0.02652363550630673
1249.0, 0.15766827773193445
1250.300048828125, 0.07515030060120241
1251.4000244140625, 0.0397854532594601
1252.0999755859375, 0.09135918896616763
1253.300048828125, 0.033891312035836375
1254.800048828125, 0.019155958976777084
1256.0999755859375, 0.09577979488388541
1257.300048828125, 0.09135918896616763
1258.199951171875, 0.030944241424024518
1258.9000244140625, 0.008841211835435576
1260.699951171875, 0.019155958976777084
1261.5999755859375, 0.05452080631851939
1262.5, 0.08399151243663798
1262.9000244140625, 0.0854650477425439
1263.5999755859375, 0.036838382647648237
1264.0999755859375, 0.07809737121301426
1264.9000244140625, 0.07367676529529647
1267.300048828125, 0.03241777672993045
1268.800048828125, 0.11346221855475656
1269.800048828125, 0.02947070611811859
1271.0, 0.017682423670871153
1271.5, 0.016208888364965226
1273.199951171875, 0.02799717081221266
1274.300048828125, 0.09577979488388541
1274.800048828125, 0.09872686549569727
1275.5999755859375, 0.07809737121301426
1276.5, 0.10904161263703878
1278.5999755859375, 0.0014735353059059295
1279.0999755859375, 0.036838382647648237
1280.5, 0.025050100200400802
1281.5, 0.07662383590710833
1282.199951171875, 0.06925615937757869
1283.300048828125, 0.05746787693033125
1284.300048828125, 0.03831191795355417
1286.0999755859375, 0.04125898856536603
1287.0, 0.05304727101261346
1287.5999755859375, 0.0795709065189202
1288.5, 0.08251797713073206
1288.800048828125, 0.07809737121301426
1290.0, 0.007367676529529648
1292.800048828125, 0.04420605917717788
1294.0, 0.12819757161381587
1294.5, 0.0795709065189202
1295.0999755859375, 0.047153129788989744
1298.9000244140625, 0.02947070611811859
1299.4000244140625, 0.061888482848049035
1300.0999755859375, 0.005894141223623718
1300.9000244140625, 0.0854650477425439
1301.800048828125, 0.03831191795355417
1303.800048828125, 0.019155958976777084
1304.699951171875, 0.0397854532594601
1305.5, 0.07367676529529647
1306.4000244140625, 0.06630908876576683
1308.199951171875, 0.12082989508428622
1311.5, 0.07809737121301426
1312.0999755859375, 0.07515030060120241
1312.800048828125, 0.11346221855475656
1313.5, 0.09430625957797949
1314.4000244140625, 0.030944241424024518
1315.0999755859375, 0.013261817753153365
1317.0, 0.0648355534598609
1317.5999755859375, 0.07809737121301426
1318.199951171875, 0.10756807733113286
1318.5999755859375, 0.10167393610750913
1319.4000244140625, 0.08399151243663798
1320.4000244140625, 0.051573735706707535
1321.0999755859375, 0.02210302958858894
1324.0, 0.09577979488388541
1325.0, 0.07809737121301426
1325.5999755859375, 0.11198868324885064
1326.300048828125, 0.06630908876576683
1327.0, 0.019155958976777084
1327.199951171875, 0.020629494282683014
1327.9000244140625, 0.02799717081221266
1329.800048828125, 0.020629494282683014
1330.300048828125, 0.051573735706707535
1331.300048828125, 0.06041494754214311
1332.0, 0.07662383590710833
1332.800048828125, 0.016208888364965226
1333.5999755859375, 0.02947070611811859
1335.800048828125, 0.04567959448308381
1336.4000244140625, 0.06925615937757869
1336.9000244140625, 0.0648355534598609
1338.0, 0.1444064599787811
1339.4000244140625, 0.03241777672993045
1340.699951171875, 0.02210302958858894
1342.0999755859375, 0.047153129788989744
1343.0, 0.0397854532594601
1343.9000244140625, 0.07220322998939055
1344.800048828125, 0.08693858304844984
1345.5999755859375, 0.02652363550630673
1346.300048828125, 0.016208888364965226
1348.699951171875, 0.050100200400801605
1349.0999755859375, 0.06630908876576683
1349.699951171875, 0.08841211835435576
1351.300048828125, 0.02652363550630673
1351.699951171875, 0.02799717081221266
1352.800048828125, 0.025050100200400802
1355.4000244140625, 0.048626665094895674
1356.0, 0.04567959448308381
1356.800048828125, 0.036838382647648237
1357.800048828125, 0.04420605917717788
1358.5999755859375, 0.02799717081221266
1359.4000244140625, 0.014735353059059295
1360.300048828125, 0.0
1361.300048828125, 0.09577979488388541
1362.0, 0.06925615937757869
1362.5, 0.051573735706707535
1363.0, 0.07515030060120241
1363.9000244140625, 0.05746787693033125
1365.199951171875, 0.020629494282683014
1368.0, 0.1444064599787811
1369.0999755859375, 0.004420605917717788
1370.4000244140625, 0.061888482848049035
1371.199951171875, 0.03241777672993045
1371.699951171875, 0.011788282447247436
1373.300048828125, 0.036838382647648237
1374.300048828125, 0.11640928916656842
1375.0, 0.061888482848049035
1375.4000244140625, 0.08693858304844984
1376.5999755859375, 0.02947070611811859
1378.5, 0.008841211835435576
1379.9000244140625, 0.06925615937757869
1380.5999755859375, 0.0854650477425439
1381.4000244140625, 0.1444064599787811
1382.699951171875, 0.06041494754214311
1386.300048828125, 0.07072969468348461
1387.300048828125, 0.06336201815395497
1388.300048828125, 0.06925615937757869
1389.4000244140625, 0.05304727101261346
1390.699951171875, 0.0014735353059059295
1392.0, 0.030944241424024518
1392.800048828125, 0.06630908876576683
1393.300048828125, 0.07220322998939055
1394.0, 0.08251797713073206
1394.800048828125, 0.09283272427207356
1396.4000244140625, 0.033891312035836375
1397.9000244140625, 0.014735353059059295
1399.0, 0.06778262407167275
1399.800048828125, 0.10314747141341507
1400.4000244140625, 0.0397854532594601
1401.0999755859375, 0.048626665094895674
1405.300048828125, 0.10314747141341507
1406.0, 0.07220322998939055
1406.800048828125, 0.11346221855475656
1407.5999755859375, 0.023576564894494872
1409.0, 0.023576564894494872
1410.800048828125, 0.06336201815395497
1411.5, 0.10609454202522692
1412.300048828125, 0.13261817753153365
1414.199951171875, 0.06336201815395497
1415.5, 0.008841211835435576
1416.9000244140625, 0.023576564894494872
1417.9000244140625, 0.0854650477425439
1418.5999755859375, 0.019155958976777084
1419.4000244140625, 0.04567959448308381
1420.4000244140625, 0.017682423670871153
1420.800048828125, 0.016208888364965226
1421.699951171875, 0.030944241424024518
1422.699951171875, 0.016208888364965226
1424.5999755859375, 0.08104444182482612
1424.9000244140625, 0.08104444182482612
1425.5, 0.008841211835435576
1426.5, 0.02652363550630673
1427.0999755859375, 0.09872686549569727
1429.4000244140625, 0.035364847341742306
1430.4000244140625, 0.11051514794294472
1431.300048828125, 0.051573735706707535
1432.0, 0.05894141223623718
1432.699951171875, 0.0014735353059059295
1433.300048828125, 0.02947070611811859
1433.9000244140625, 0.011788282447247436
1435.300048828125, 0.0648355534598609
1435.800048828125, 0.047153129788989744
1436.5999755859375, 0.11935635977838029
1437.4000244140625, 0.07220322998939055
1438.199951171875, 0.07367676529529647
1438.9000244140625, 0.016208888364965226
1441.4000244140625, 0.025050100200400802
1442.5, 0.06630908876576683
1443.5, 0.05304727101261346
1444.199951171875, 0.051573735706707535
1444.699951171875, 0.017682423670871153
1445.199951171875, 0.035364847341742306
1445.800048828125, 0.04420605917717788
1446.5, 0.02947070611811859
1447.0, 0.033891312035836375
1448.0, 0.02799717081221266
1449.199951171875, 0.06041494754214311
##PAGE=T= 0.021633333333333334
##NPOINTS=1098
##DATA TABLE=(XY..XY)
100.4000015258789, 22.445998923821968
101.9000015258789, 51.54892766546237
103.5999984741211, 47.57475593819663
104.30000305175781, 34.99884695211008
105.69999694824219, 50.849411945576136
107.4000015258789, 15.158736259512644
108.80000305175781, 23.968022138519487
109.69999694824219, 20.101468214313165
110.5, 26.335613805826736
111.69999694824219, 7.81766469367361
112.69999694824219, 18.225843646706124
114.0999984741211, 22.492120839418863
115.19999694824219, 6.6415558459528015
117.30000305175781, 64.50918594818971
118.30000305175781, 65.59305096471672
119.19999694824219, 31.124606041970942
120.30000305175781, 12.737335690675685
121.19999694824219, 23.637481743408408
122.69999694824219, 100.0
123.9000015258789, 8.202013990314397
124.5999984741211, 11.507417941425167
125.5999984741211, 12.591282957952187
127.5999984741211, 27.80382811899454
128.39999389648438, 64.10946267968329
129.3000030517578, 40.0876316396341
130.0, 30.378968406487814
131.5, 66.66922899531093
132.10000610351562, 78.47643938811592
133.6999969482422, 21.83104004919671
134.10000610351562, 21.262203090168345
136.39999389648438, 25.628411100007686
137.60000610351562, 83.41148435698362
138.10000610351562, 66.13113998001383
139.3000030517578, 12.00707202705819
140.5, 19.00991621185333
142.10000610351562, 54.09332000922438
143.3000030517578, 15.773695134137904
144.10000610351562, 17.487892997155814
145.5, 20.662618187408714
146.39999389648438, 27.634714428472595
149.6999969482422, 91.08309631793374
150.3000030517578, 78.83004074102544
151.5, 20.416634637558612
152.1999969482422, 20.009224383119378
152.6999969482422, 14.60527327234991
153.39999389648438, 11.945576139595664
154.3000030517578, 5.980475055730648
155.0, 12.491352140825581
155.6999969482422, 5.1733415327849945
156.8000030517578, 10.684910446613882
157.8000030517578, 23.85271734952725
159.10000610351562, 20.570374356214927
160.5, 9.139826274117917
161.1999969482422, 16.058113613652086
162.60000610351562, 7.40256745330156
164.60000610351562, 11.79183642093935
165.39999389648438, 12.868014451533552
166.3000030517578, 8.494119455761396
167.8000030517578, 6.195710661849488
168.6999969482422, 8.693981090014605
170.1999969482422, 7.410254439234376
170.89999389648438, 9.754785148743178
173.39999389648438, 6.8798524098700895
174.39999389648438, 3.93573679760166
175.0, 3.6282573602890307
175.39999389648438, 3.9280498116688443
176.39999389648438, 5.63456068875394
177.5, 4.704435390883234
178.5, 3.528326543162426
179.0, 3.436082711968637
180.5, 9.547236528557152
181.0, 9.593358444154047
182.60000610351562, 8.809285879006842
183.1999969482422, 6.380198324237067
184.8000030517578, 9.470366669228994
186.39999389648438, 10.269813206241832
187.3000030517578, 2.598201245291721
188.1999969482422, 1.345222538242755
189.1999969482422, 1.2991006226458606
190.3000030517578, 2.029364286263356
191.39999389648438, 2.0216773003305404
193.39999389648438, 7.986778384195556
194.0, 9.647167345683757
195.8000030517578, 11.276808363440693
196.5, 5.626873702821124
197.0, 6.841417480206011
198.60000610351562, 12.022445998923821
200.3000030517578, 10.169882389115227
201.60000610351562, 10.338996079637173
202.10000610351562, 13.636713044815128
204.39999389648438, 7.14889691751864
205.8000030517578, 4.212468291183027
207.39999389648438, 2.1292951033899605
208.10000610351562, 4.143285417787685
210.10000610351562, 11.146129602582826
211.3000030517578, 11.222999461910984
213.0, 7.379506495503112
213.8000030517578, 4.427703897301868
216.3000030517578, 11.64578368821585
217.39999389648438, 4.158659389653317
218.1999969482422, 3.351525866707664
219.10000610351562, 5.211776462449073
220.89999389648438, 3.6820662618187407
222.39999389648438, 4.527634714428473
224.0, 3.4745176416327155
225.0, 6.2648935352448305
226.1999969482422, 4.719809362748866
227.1999969482422, 3.3592128526404794
227.89999389648438, 2.336843723575986
229.0, 8.217387962180029
230.5, 3.436082711968637
231.60000610351562, 5.104158659389653
232.39999389648438, 9.94695979706357
233.5, 5.327081251441309
234.89999389648438, 2.113921131524329
235.39999389648438, 2.060112229994619
236.3000030517578, 4.158659389653317
237.39999389648438, 6.149588746252594
238.1999969482422, 5.949727111999385
240.5, 5.496194941963256
242.1999969482422, 3.6205703743562148
242.6999969482422, 4.927357982934891
243.5, 4.981166884464601
246.1999969482422, 2.32915673764317
247.0, 3.343838880774848
248.60000610351562, 8.70166807594742
249.8000030517578, 6.864478438004458
252.1999969482422, 16.803751249135214
253.60000610351562, 12.629717887616264
254.3000030517578, 6.357137366438619
255.39999389648438, 5.819048351141517
256.1000061035156, 8.801598893074026
257.1000061035156, 3.2054731339841647
258.6000061035156, 3.8281189945422396
260.70001220703125, 27.296487047428702
262.20001220703125, 12.26074256284111
263.1000061035156, 13.113998001383656
264.5, 1.1146129602582826
266.20001220703125, 8.801598893074026
268.0, 4.389268967637789
268.6000061035156, 4.735183334614497
270.29998779296875, 1.9524944269351987
271.29998779296875, 10.600353601352909
272.20001220703125, 7.794603735875163
273.0, 2.567453301560458
273.8999938964844, 4.297025136444
274.5, 2.398339611038512
275.5, 2.121608117457145
276.20001220703125, 4.642939503420709
277.29998779296875, 13.836574679068336
278.29998779296875, 14.420785609962333
280.1000061035156, 9.593358444154047
280.6000061035156, 8.939964639864709
282.1000061035156, 26.251056960565762
283.8999938964844, 22.94565300945499
284.8999938964844, 12.32992543623645
285.79998779296875, 18.302713506034284
287.3999938964844, 2.413713582904143
289.70001220703125, 5.357829195172573
290.5, 5.227150434314705
291.5, 7.29494965024214
292.3999938964844, 5.134906603120916
293.6000061035156, 5.834422323007148
295.8999938964844, 5.857483280805596
296.8999938964844, 8.586363286955184
297.5, 6.710738719348143
298.0, 4.235529248981474
299.8999938964844, 15.012683526789145
301.20001220703125, 4.55069567222692
302.3999938964844, 15.842878007533246
304.0, 19.655623030209853
306.0, 9.278192020908602
307.0, 5.311707279575678
307.70001220703125, 11.39211315243293
308.8999938964844, 10.431239910830962
310.1000061035156, 7.863786609270504
311.6000061035156, 17.633945729879315
312.29998779296875, 34.93735106464755
313.29998779296875, 16.350219079099084
314.0, 8.148205088784687
315.5, 6.372511338304251
316.5, 4.5660696440925514
317.1000061035156, 7.04127911445922
318.20001220703125, 1.9140594972711198
319.6000061035156, 7.594742101621954
319.8999938964844, 7.633177031286032
321.20001220703125, 4.281651164578369
322.0, 7.879160581136136
322.79998779296875, 20.40126066569298
323.5, 28.787762318394957
324.5, 3.15935121838727
325.1000061035156, 3.8050580367437927
326.1000061035156, 1.7065108770850947
328.5, 34.62987162733492
329.29998779296875, 4.512260742562841
330.6000061035156, 4.3200860942424475
331.70001220703125, 4.8120531939426545
333.0, 4.773618264278576
334.29998779296875, 8.840033822738103
336.1000061035156, 5.680682604350833
337.3999938964844, 8.79391190714121
338.5, 7.825351679606426
340.1000061035156, 5.027288800061496
341.70001220703125, 1.3067876085786763
343.1000061035156, 6.902913367668536
345.0, 3.282342993312322
346.6000061035156, 5.680682604350833
349.1000061035156, 5.7959873933430694
350.6000061035156, 3.2515950495810593
352.0, 5.788300407410254
353.79998779296875, 3.9511107694672916
354.8999938964844, 7.640864017218848
356.5, 3.228534091782612
357.1000061035156, 5.1272196171881
357.6000061035156, 5.5346298716273346
358.8999938964844, 3.2669690214466907
359.70001220703125, 0.7610116073487585
361.1000061035156, 3.4745176416327155
362.0, 3.4437696979014527
363.1000061035156, 5.519255899761703
364.5, 5.972788069797832
365.0, 4.535321700361288
365.79998779296875, 9.939272811130754
366.3999938964844, 3.5360135290952415
368.0, 2.1292951033899605
369.6000061035156, 12.629717887616264
370.3999938964844, 17.311092320701054
372.8999938964844, 4.773618264278576
374.1000061035156, 4.35083403797371
377.3999938964844, 4.166346375586133
378.5, 1.252978707048966
379.6000061035156, 5.465446998231993
380.20001220703125, 1.375970481974018
380.8999938964844, 2.175417018986855
381.6000061035156, 2.8441847951418247
383.8999938964844, 4.727496348681681
385.0, 5.511568913828888
385.79998779296875, 1.96786839880083
386.8999938964844, 5.334768237374125
388.8999938964844, 9.001460527327234
390.29998779296875, 7.9637174263971096
391.1000061035156, 3.3899607963717426
392.29998779296875, 8.478745483895764
393.79998779296875, 9.439618725497732
394.70001220703125, 0.5842109308939964
395.5, 2.513644400030748
396.3999938964844, 0.1998616342532093
397.20001220703125, 0.4458451841033131
399.29998779296875, 4.9350449688677065
400.79998779296875, 59.15135675301714
402.0, 93.57367976016603
403.79998779296875, 60.05073410715658
404.3999938964844, 63.702052425244055
405.20001220703125, 11.169190560381274
407.1000061035156, 1.7218848489507264
409.6000061035156, 1.96786839880083
411.0, 5.4193250826350985
412.29998779296875, 2.1446690752555924
412.8999938964844, 2.5290183718963792
413.3999938964844, 2.398339611038512
416.6000061035156, 5.84979629487278
417.5, 2.713506034283957
418.29998779296875, 3.52063955722961
419.20001220703125, 0.5304020293642863
420.70001220703125, 3.074794373126297
421.20001220703125, 3.851179952340687
422.79998779296875, 0.5304020293642863
424.70001220703125, 4.24321623491429
425.29998779296875, 2.7673149358136673
427.1000061035156, 0.7072027058190483
427.70001220703125, 0.476593127834576
428.8999938964844, 2.9056806826043506
429.70001220703125, 1.6527019755553847
430.79998779296875, 2.6058882312245366
431.8999938964844, 3.2439080636482434
433.79998779296875, 1.1530478899223613
436.0, 3.0056114997309553
436.6000061035156, 4.212468291183027
437.20001220703125, 2.32915673764317
438.5, 2.359904681374433
439.6000061035156, 2.9748635559996925
440.79998779296875, 0.16911369052194633
442.0, 7.471750326696902
443.0, 2.359904681374433
444.0, 0.2536705357829195
444.6000061035156, 0.6380198324237066
445.0, 0.4842801137673918
446.29998779296875, 5.811361365208701
447.0, 3.282342993312322
447.70001220703125, 4.481512798831578
448.3999938964844, 2.682758090552694
449.5, 1.8909985394726727
451.20001220703125, 0.08455684526097317
453.0, 4.396955953570605
454.20001220703125, 3.2515950495810593
455.0, 0.16911369052194633
456.3999938964844, 1.9524944269351987
458.20001220703125, 0.983934199400415
459.20001220703125, 0.5842109308939964
460.0, 0.476593127834576
460.70001220703125, 0.2921054654469982
461.5, 0.4612191559689445
463.70001220703125, 4.143285417787685
464.79998779296875, 3.551387500960873
465.79998779296875, 4.8120531939426545
467.3999938964844, 2.990237527865324
468.20001220703125, 0.5534629871627335
469.8999938964844, 2.6135752171573525
471.3999938964844, 6.218771619647936
473.0, 1.1607348758551772
475.79998779296875, 4.0817895303251595
476.5, 2.444461526635406
477.5, 1.8295026520101467
478.1000061035156, 1.314474594511492
479.3999938964844, 0.4842801137673918
479.8999938964844, 0.31516642324544547
480.70001220703125, 0.43815819817049734
481.8999938964844, 2.6443231608886153
483.3999938964844, 0.476593127834576
484.8999938964844, 3.6205703743562148
486.79998779296875, 3.8896148820047656
487.8999938964844, 4.996540856330233
489.70001220703125, 4.1970943193173955
491.0, 1.3067876085786763
492.5, 2.0677992159274345
493.3999938964844, 0.3459143669767084
496.0, 0.09224383119378891
496.8999938964844, 0.299792451379814
498.6000061035156, 6.203397647782304
499.79998779296875, 1.2452917211161503
500.70001220703125, 1.345222538242755
501.3999938964844, 1.6527019755553847
502.3999938964844, 3.0056114997309553
503.0, 2.628949189022984
503.6000061035156, 3.374586824506111
504.29998779296875, 0.11530478899223613
506.20001220703125, 8.317318779306634
507.5, 4.81974017987547
508.3999938964844, 0.35360135290952416
510.1000061035156, 0.4150972403720501
510.6000061035156, 0.35360135290952416
511.8999938964844, 4.250903220847106
512.7000122070312, 1.9832423706664615
514.4000244140625, 0.16911369052194633
515.4000244140625, 3.0132984856637712
516.0, 1.3990314397724652
516.9000244140625, 0.3612883388423399
517.4000244140625, 0.36897532477515566
518.0, 0.4150972403720501
518.5999755859375, 0.015373971865631485
519.7999877929688, 1.6603889614882004
520.4000244140625, 0.24598354985010376
521.0999755859375, 0.06918287339534168
522.4000244140625, 5.749865477746176
523.2000122070312, 2.0139903143977245
524.2999877929688, 2.598201245291721
525.4000244140625, 0.1998616342532093
525.7999877929688, 0.08455684526097317
527.2000122070312, 2.167730033054039
528.2999877929688, 0.5227150434314705
529.4000244140625, 1.5143362287647013
530.0999755859375, 0.04612191559689446
530.5, 0.24598354985010376
531.2999877929688, 0.13836574679068336
532.7000122070312, 0.3305403951110769
533.5999755859375, 1.0377431009301252
534.9000244140625, 1.8679375816742254
535.5999755859375, 1.7372588208163577
536.2000122070312, 1.998616342532093
537.5, 0.20754862018602505
539.4000244140625, 2.8903067107387193
540.4000244140625, 0.299792451379814
541.5999755859375, 0.23060957798447226
543.0, 1.5066492428318856
545.0999755859375, 2.213851948650934
546.2999877929688, 7.333384579906219
547.2000122070312, 0.6457068183565223
549.0999755859375, 2.398339611038512
550.0, 1.7218848489507264
551.7000122070312, 0.8686294104081789
553.2000122070312, 0.5534629871627335
554.5, 2.5213313859635638
555.4000244140625, 0.19217464832039358
559.2999877929688, 1.7987547082788837
560.0999755859375, 0.568836959028365
561.0, 1.2606656929817819
562.4000244140625, 2.359904681374433
563.0, 1.5373971865631486
563.9000244140625, 4.9196709970020756
566.2000122070312, 3.551387500960873
566.9000244140625, 0.40741025443923434
567.9000244140625, 3.2977169651779534
569.2000122070312, 0.33822738104389266
573.4000244140625, 7.879160581136136
574.5, 0.12299177492505188
576.0999755859375, 2.813436851410562
577.5999755859375, 3.336151894842032
578.5999755859375, 0.8993773541394419
579.5999755859375, 0.6380198324237066
580.5, 0.2844184795141825
584.2999877929688, 0.5534629871627335
585.5, 1.6527019755553847
586.7000122070312, 0.2921054654469982
587.2000122070312, 0.45353217003612883
590.5999755859375, 6.334076408640172
592.7000122070312, 3.5052655853639787
593.2999877929688, 2.4367745407025905
594.2000122070312, 0.6764547620877853
595.0999755859375, 0.299792451379814
596.2000122070312, 0.507341071565839
596.7999877929688, 0.3766623107079714
597.4000244140625, 0.5150280574986548
597.7000122070312, 0.4612191559689445
598.7999877929688, 0.4304712122376816
599.7000122070312, 1.7756937504804364
600.5, 0.40741025443923434
602.2999877929688, 0.5611499730955493
604.5, 2.9133676685371666
606.2000122070312, 1.9140594972711198
608.0, 1.522023214697517
608.7999877929688, 0.2767314935813667
609.5, 0.40741025443923434
610.5999755859375, 1.4451533553693596
611.4000244140625, 0.4689061419017603
613.0999755859375, 1.1222999461910985
615.5999755859375, 1.468214313167807
617.4000244140625, 4.089476516257975
618.2000122070312, 0.40741025443923434
621.5, 5.688369590283649
624.4000244140625, 2.4982704281651165
625.7000122070312, 0.18448766238757783
626.2999877929688, 0.17680067645476208
627.5999755859375, 0.17680067645476208
628.5999755859375, 0.568836959028365
631.2000122070312, 3.0671073871934813
631.9000244140625, 0.17680067645476208
633.0999755859375, 6.764547620877853
634.9000244140625, 0.538089015297102
635.5, 0.3459143669767084
636.2999877929688, 0.5457760012299178
637.0, 0.2152356061188408
639.5999755859375, 0.31516642324544547
640.0999755859375, 0.6149588746252594
640.9000244140625, 0.6380198324237066
641.5, 0.4304712122376816
643.5999755859375, 2.6750711046198785
645.7000122070312, 6.180336689983857
647.2999877929688, 0.5611499730955493
648.0999755859375, 1.729571834883542
649.2000122070312, 2.7980628795449305
650.2000122070312, 0.17680067645476208
651.5, 1.0992389883926512
652.7000122070312, 1.6603889614882004
653.2999877929688, 1.0992389883926512
654.5, 0.35360135290952416
655.7000122070312, 2.69044507648551
657.7999877929688, 2.659697132754247
658.4000244140625, 1.460527327234991
659.5999755859375, 3.9895456991313702
660.2999877929688, 0.599584902759628
661.5999755859375, 0.6303328464908909
664.5999755859375, 0.11530478899223613
665.5999755859375, 0.4689061419017603
666.7000122070312, 1.729571834883542
668.0999755859375, 0.299792451379814
668.9000244140625, 0.7379506495503113
671.0, 3.167038204320086
672.7999877929688, 6.695364747482512
673.9000244140625, 0.24598354985010376
674.7000122070312, 0.922438311937889
676.9000244140625, 0.2844184795141825
677.4000244140625, 0.42278422630486584
679.2000122070312, 3.0056114997309553
681.0, 3.0132984856637712
681.9000244140625, 0.7379506495503113
682.9000244140625, 3.551387500960873
684.2000122070312, 2.5290183718963792
685.2000122070312, 1.3605965101083863
686.0, 0.2767314935813667
686.9000244140625, 0.12299177492505188
687.9000244140625, 0.2152356061188408
688.7999877929688, 0.49965408563302327
689.0999755859375, 0.4689061419017603
690.9000244140625, 1.698823891152279
693.0999755859375, 0.31516642324544547
694.2000122070312, 2.652010146821431
695.2000122070312, 0.23060957798447226
696.0, 0.299792451379814
696.7999877929688, 0.6380198324237066
698.0, 2.867245752940272
699.7999877929688, 2.6673841186870626
700.7999877929688, 0.8916903682066262
701.7999877929688, 2.8288108232761933
703.2000122070312, 2.183104004919671
704.0, 0.42278422630486584
704.7000122070312, 0.2921054654469982
707.0, 0.19217464832039358
708.7000122070312, 0.39203628257360285
710.0, 3.6590053040202934
711.9000244140625, 3.0056114997309553
712.4000244140625, 3.282342993312322
712.9000244140625, 3.0594204012606654
713.7999877929688, 3.336151894842032
715.0999755859375, 4.0817895303251595
717.0, 2.1907909908524865
718.7999877929688, 0.4689061419017603
721.5, 1.6065800599584903
722.4000244140625, 2.1446690752555924
724.0999755859375, 0.16142670458913058
724.5999755859375, 0.4458451841033131
728.0, 0.5227150434314705
728.2999877929688, 0.5534629871627335
729.0999755859375, 0.42278422630486584
730.0, 0.7610116073487585
730.7000122070312, 0.07686985932815743
733.2000122070312, 0.31516642324544547
733.5999755859375, 0.42278422630486584
734.5, 2.236912906449381
735.2999877929688, 0.5304020293642863
735.5999755859375, 0.5304020293642863
736.2000122070312, 0.13067876085786762
737.2999877929688, 0.2536705357829195
739.4000244140625, 2.6443231608886153
740.5, 5.834422323007148
741.7000122070312, 2.5520793296948265
742.2999877929688, 2.536705357829195
743.4000244140625, 0.5457760012299178
744.7999877929688, 0.2152356061188408
745.5999755859375, 0.11530478899223613
746.5999755859375, 0.3766623107079714
747.0999755859375, 0.42278422630486584
747.7000122070312, 0.26135752171573523
748.7000122070312, 0.1460527327234991
749.5999755859375, 0.06149588746252594
752.0, 5.642247674686755
753.0, 0.5304020293642863
754.7999877929688, 2.229225920516565
756.2999877929688, 0.17680067645476208
757.5, 0.03074794373126297
758.5, 0.5227150434314705
759.2999877929688, 0.7225766776846798
763.9000244140625, 0.1076178030594204
764.7999877929688, 0.31516642324544547
765.5, 0.299792451379814
766.7999877929688, 3.351525866707664
767.7000122070312, 0.1998616342532093
768.9000244140625, 1.045430086862941
769.7000122070312, 2.713506034283957
771.4000244140625, 0.17680067645476208
772.0999755859375, 0.3766623107079714
774.2999877929688, 3.113229302790376
775.5999755859375, 3.0594204012606654
776.2999877929688, 1.1837958336536243
777.0999755859375, 2.713506034283957
778.0999755859375, 1.4220923975709123
780.0, 1.9140594972711198
782.0, 0.04612191559689446
783.0999755859375, 0.23060957798447226
784.7999877929688, 4.09716350219079
785.5999755859375, 1.2145437773848873
786.2000122070312, 0.19217464832039358
787.5999755859375, 2.3060957798447226
788.2999877929688, 2.7596279498808514
789.2999877929688, 0.13836574679068336
790.5, 0.4458451841033131
791.5999755859375, 0.2767314935813667
793.2000122070312, 0.40741025443923434
794.5, 0.1460527327234991
795.2999877929688, 0.7917595510800215
796.4000244140625, 0.31516642324544547
797.5, 0.5534629871627335
798.5, 2.6366361749558
800.2999877929688, 2.359904681374433
801.2999877929688, 1.0069951571988622
803.4000244140625, 3.528326543162426
805.4000244140625, 0.8916903682066262
805.9000244140625, 0.6380198324237066
807.2000122070312, 1.875624567607041
809.9000244140625, 2.0139903143977245
810.2000122070312, 2.0139903143977245
812.2000122070312, 2.982550541932508
814.2999877929688, 0.3305403951110769
815.2999877929688, 3.1747251902529015
816.5, 1.4144054116380966
818.2000122070312, 2.0754862018602505
819.0999755859375, 4.9350449688677065
820.7000122070312, 1.844876623875778
822.5, 3.5590744868936888
823.9000244140625, 0.7225766776846798
825.4000244140625, 0.13836574679068336
826.0, 0.17680067645476208
827.0, 0.16142670458913058
827.7999877929688, 0.22292259205165654
830.0, 4.058728572526712
831.2000122070312, 1.55277115842878
833.7000122070312, 0.5304020293642863
834.7999877929688, 4.043354600661081
835.7999877929688, 0.4150972403720501
837.2999877929688, 3.551387500960873
838.7999877929688, 1.875624567607041
839.5999755859375, 0.4458451841033131
840.4000244140625, 0.4150972403720501
841.0999755859375, 0.45353217003612883
842.0999755859375, 0.568836959028365
843.5, 2.7596279498808514
846.5, 2.8518717810746406
847.2000122070312, 0.36897532477515566
848.2999877929688, 2.1292951033899605
850.2000122070312, 3.10554231685756
851.0, 2.413713582904143
852.0, 0.13067876085786762
853.5, 1.8986855254054884
854.5, 0.49965408563302327
856.7999877929688, 5.081097701591206
857.9000244140625, 0.12299177492505188
859.9000244140625, 2.69044507648551
860.7000122070312, 0.2767314935813667
861.0, 0.2921054654469982
862.9000244140625, 1.8295026520101467
865.0, 1.3990314397724652
866.7000122070312, 0.40741025443923434
869.2000122070312, 0.299792451379814
871.7000122070312, 0.31516642324544547
872.5999755859375, 0.6533938042893381
873.2999877929688, 0.7994465370128372
874.0999755859375, 0.5150280574986548
875.0999755859375, 1.1299869321239142
877.4000244140625, 0.9993081712660465
878.0999755859375, 0.4458451841033131
878.7000122070312, 0.5611499730955493
879.4000244140625, 0.3074794373126297
880.0999755859375, 0.07686985932815743
881.2999877929688, 0.0076869859328157425
883.0999755859375, 2.3675916673072486
883.7999877929688, 0.3459143669767084
884.5, 0.35360135290952416
885.0, 0.3459143669767084
886.0, 0.6226458605580751
887.0, 0.2844184795141825
889.0999755859375, 0.0076869859328157425
890.0, 0.19217464832039358
891.7000122070312, 3.57444845875932
892.4000244140625, 0.17680067645476208
893.5, 0.3074794373126297
894.5999755859375, 5.134906603120916
896.2999877929688, 4.227842263048658
897.2000122070312, 3.4898916134983473
899.0999755859375, 2.1292951033899605
900.0999755859375, 0.3305403951110769
901.7000122070312, 0.3305403951110769
903.2999877929688, 1.8909985394726727
906.7000122070312, 2.1446690752555924
907.7000122070312, 2.1292951033899605
909.5999755859375, 1.6527019755553847
910.4000244140625, 1.4451533553693596
911.5, 3.6666922899531094
913.2000122070312, 0.0538089015297102
914.4000244140625, 0.9454992697363364
915.5, 3.097855330924744
916.5, 0.9301252978707049
917.4000244140625, 0.7302636636174955
918.4000244140625, 0.0538089015297102
922.0, 7.425628411100007
923.7000122070312, 5.980475055730648
924.9000244140625, 3.405334768237374
927.5, 0.07686985932815743
928.0999755859375, 0.476593127834576
929.0, 0.6841417480206011
930.7000122070312, 1.883311553539857
931.9000244140625, 1.4451533553693596
932.7000122070312, 1.55277115842878
933.4000244140625, 0.3305403951110769
934.0, 0.5534629871627335
935.7000122070312, 1.998616342532093
936.4000244140625, 0.1998616342532093
938.0, 0.015373971865631485
940.2999877929688, 1.2991006226458606
941.5, 0.568836959028365
942.5999755859375, 0.5150280574986548
943.5, 0.07686985932815743
944.2000122070312, 0.0076869859328157425
946.0999755859375, 1.2452917211161503
947.5, 0.507341071565839
948.2000122070312, 0.1998616342532093
949.2000122070312, 0.23060957798447226
950.4000244140625, 2.536705357829195
951.7000122070312, 4.258590206779921
952.7000122070312, 2.867245752940272
953.4000244140625, 1.345222538242755
954.2999877929688, 0.4842801137673918
955.5, 4.035667614728265
956.2999877929688, 0.06918287339534168
958.5, 0.6226458605580751
960.2000122070312, 1.6065800599584903
962.0, 3.5590744868936888
963.5, 0.1076178030594204
964.5, 1.9140594972711198
966.0999755859375, 0.5918979168268121
967.5, 1.0223691290644938
969.0999755859375, 1.5297102006303327
971.0999755859375, 3.966484741332923
971.5999755859375, 2.867245752940272
972.9000244140625, 0.6380198324237066
973.7999877929688, 0.269044507648551
974.2999877929688, 0.09224383119378891
976.7999877929688, 0.6457068183565223
977.5, 0.1076178030594204
978.2999877929688, 0.49965408563302327
980.0, 1.2299177492505189
983.0, 0.20754862018602505
983.4000244140625, 0.20754862018602505
983.7999877929688, 0.1998616342532093
984.4000244140625, 0.299792451379814
984.7999877929688, 0.45353217003612883
985.5, 0.3305403951110769
986.2999877929688, 0.8455684526097317
987.5, 0.04612191559689446
988.4000244140625, 0.22292259205165654
990.9000244140625, 3.4283957260358213
991.7999877929688, 0.6072718886924436
992.5999755859375, 0.6610807902221538
993.9000244140625, 0.7302636636174955
994.7000122070312, 0.02306095779844723
995.5999755859375, 0.3074794373126297
997.0, 3.4822046275655314
998.0999755859375, 0.5304020293642863
999.5, 2.3137827657775385
1000.0, 1.998616342532093
1001.2000122070312, 1.583519102160043
1003.0999755859375, 3.343838880774848
1003.9000244140625, 0.3612883388423399
1004.7000122070312, 0.2536705357829195
1006.0, 1.583519102160043
1007.5, 3.635944346221846
1008.0, 3.5975094165577675
1008.7999877929688, 2.090860173725882
1009.7999877929688, 0.43815819817049734
1011.2000122070312, 3.097855330924744
1014.2999877929688, 0.3305403951110769
1015.0, 0.3997232685064186
1016.0, 0.9454992697363364
1017.0, 0.3997232685064186
1017.7999877929688, 0.507341071565839
1020.2000122070312, 3.789684064878161
1021.0999755859375, 0.49965408563302327
1021.9000244140625, 0.35360135290952416
1022.5, 0.24598354985010376
1023.0, 0.1998616342532093
1024.300048828125, 0.2767314935813667
1025.5, 2.874932738873088
1026.5, 5.949727111999385
1027.9000244140625, 0.40741025443923434
1029.0, 0.538089015297102
1030.699951171875, 2.4675224844338532
1032.699951171875, 1.491275270966254
1033.4000244140625, 0.20754862018602505
1034.9000244140625, 1.7141978630179107
1035.9000244140625, 3.097855330924744
1037.699951171875, 2.113921131524329
1039.199951171875, 0.0538089015297102
1040.5999755859375, 1.55277115842878
1041.9000244140625, 3.966484741332923
1043.0, 0.23060957798447226
1046.300048828125, 1.4220923975709123
1047.0999755859375, 3.3207779229764007
1047.699951171875, 0.4689061419017603
1048.800048828125, 0.18448766238757783
1051.0, 0.08455684526097317
1051.9000244140625, 0.20754862018602505
1053.0, 0.6149588746252594
1053.800048828125, 0.43815819817049734
1054.699951171875, 0.538089015297102
1056.9000244140625, 4.735183334614497
1057.699951171875, 0.038434929664078715
1058.5, 0.12299177492505188
1059.0999755859375, 0.2152356061188408
1060.0999755859375, 4.6967484049504185
1060.800048828125, 1.5912060880928587
1062.199951171875, 0.38434929664078715
1063.5, 3.5437005150280574
1065.199951171875, 3.4283957260358213
1066.0, 0.6610807902221538
1066.699951171875, 0.2921054654469982
1067.699951171875, 1.0915520024598355
1069.9000244140625, 0.1076178030594204
1071.300048828125, 1.760319778614805
1072.4000244140625, 0.43815819817049734
1073.5999755859375, 1.4989622568990697
1074.300048828125, 0.09993081712660465
1075.300048828125, 0.3997232685064186
1075.800048828125, 0.2536705357829195
1077.800048828125, 1.4835882850334383
1079.5, 1.8602505957414097
1080.9000244140625, 4.873549081405181
1083.300048828125, 3.044046429395034
1084.5999755859375, 4.5737566300253665
1085.9000244140625, 2.2599738642478284
1088.0, 0.1460527327234991
1088.699951171875, 0.6303328464908909
1089.5, 1.468214313167807
1090.199951171875, 0.7994465370128372
1091.4000244140625, 0.3766623107079714
1092.4000244140625, 0.13836574679068336
1093.0, 0.11530478899223613
1093.5999755859375, 0.1998616342532093
1094.699951171875, 1.0838650165270196
1095.9000244140625, 0.39203628257360285
1097.0, 0.599584902759628
1097.800048828125, 0.953186255669152
1098.5999755859375, 0.9685602275347835
1101.199951171875, 2.4982704281651165
1102.9000244140625, 4.112537474056422
1103.5999755859375, 3.405334768237374
1105.199951171875, 3.920362825736029
1106.5, 1.5066492428318856
1107.0999755859375, 0.42278422630486584
1108.4000244140625, 0.299792451379814
1109.9000244140625, 3.313090937043585
1111.5, 3.0056114997309553
1114.699951171875, 0.476593127834576
1115.199951171875, 0.6303328464908909
1116.800048828125, 3.5975094165577675
1117.5999755859375, 3.228534091782612
1118.699951171875, 2.0216773003305404
1119.800048828125, 3.4822046275655314
1121.5999755859375, 2.936428626335614
1122.699951171875, 0.6610807902221538
1123.699951171875, 2.4675224844338532
1126.5, 3.0132984856637712
1127.4000244140625, 1.468214313167807
1129.0999755859375, 4.0817895303251595
1129.699951171875, 4.481512798831578
1131.0, 0.7917595510800215
1132.5999755859375, 0.1460527327234991
1133.199951171875, 0.38434929664078715
1133.699951171875, 0.5150280574986548
1135.5, 1.199169805519256
1136.300048828125, 0.4689061419017603
1139.0999755859375, 6.111153816588516
1140.0999755859375, 2.6366361749558
1140.9000244140625, 3.2669690214466907
1141.5999755859375, 0.08455684526097317
1142.199951171875, 0.19217464832039358
1142.800048828125, 0.33822738104389266
1145.699951171875, 1.883311553539857
1146.4000244140625, 0.19217464832039358
1146.800048828125, 0.16142670458913058
1147.5999755859375, 0.49965408563302327
1148.9000244140625, 6.595433930355907
1149.9000244140625, 0.0076869859328157425
1152.5999755859375, 2.7826889076792987
1153.5999755859375, 0.32285340917826116
1155.0, 1.4835882850334383
1158.0, 0.38434929664078715
1159.5999755859375, 4.373894995772157
1160.4000244140625, 3.851179952340687
1161.5, 0.2767314935813667
1162.300048828125, 0.08455684526097317
1163.5999755859375, 3.920362825736029
1164.699951171875, 1.7449458067491737
1165.9000244140625, 0.3074794373126297
1166.5, 0.7225766776846798
1167.699951171875, 0.2921054654469982
1169.0, 0.13836574679068336
1169.9000244140625, 3.0056114997309553
1170.5999755859375, 0.3612883388423399
1171.699951171875, 0.476593127834576
1172.0, 0.4689061419017603
1172.699951171875, 0.43815819817049734
1173.699951171875, 1.875624567607041
1174.4000244140625, 0.2921054654469982
1175.5999755859375, 2.775001921746483
1178.0999755859375, 1.8064416942116994
1178.9000244140625, 0.5918979168268121
1180.800048828125, 0.18448766238757783
1183.4000244140625, 0.5227150434314705
1184.5999755859375, 6.726112691213775
1186.199951171875, 0.26135752171573523
1189.699951171875, 0.33822738104389266
1190.699951171875, 1.5450841724959643
1191.300048828125, 1.7680067645476207
1192.0999755859375, 0.31516642324544547
1192.9000244140625, 0.16911369052194633
1193.5, 0.38434929664078715
1196.199951171875, 0.7302636636174955
1197.300048828125, 0.40741025443923434
1197.9000244140625, 0.23060957798447226
1199.699951171875, 0.1076178030594204
1200.9000244140625, 0.7302636636174955
1201.9000244140625, 0.3074794373126297
1203.5, 2.336843723575986
1204.4000244140625, 0.476593127834576
1205.300048828125, 0.13067876085786762
1205.5999755859375, 0.13067876085786762
1207.199951171875, 0.03074794373126297
1207.9000244140625, 0.07686985932815743
1208.4000244140625, 0.1460527327234991
1209.4000244140625, 0.43815819817049734
1209.9000244140625, 0.24598354985010376
1210.300048828125, 0.32285340917826116
1211.0, 0.7225766776846798
1211.9000244140625, 2.1062341455915137
1213.800048828125, 0.2767314935813667
1215.5999755859375, 2.628949189022984
1217.0999755859375, 0.4458451841033131
1218.0999755859375, 0.4842801137673918
1219.699951171875, 3.113229302790376
1222.0, 21.14689830117611
1223.5, 0.13067876085786762
1225.199951171875, 0.15373971865631486
1226.0999755859375, 0.11530478899223613
1227.0, 0.23060957798447226
1227.9000244140625, 1.1761088477208086
1229.0999755859375, 0.6380198324237066
1229.800048828125, 0.24598354985010376
1232.699951171875, 0.42278422630486584
1233.300048828125, 0.33822738104389266
1234.199951171875, 0.5457760012299178
1235.199951171875, 0.4919670997002075
1235.9000244140625, 0.5918979168268121
1237.199951171875, 0.807133522945653
1239.4000244140625, 0.22292259205165654
1240.0, 0.4689061419017603
1241.0, 0.36897532477515566
1242.300048828125, 2.4367745407025905
1243.199951171875, 1.6296410177569374
1244.0999755859375, 2.7826889076792987
1244.800048828125, 3.57444845875932
1245.800048828125, 0.7917595510800215
1246.800048828125, 0.6380198324237066
1247.5, 0.4612191559689445
1248.699951171875, 0.1076178030594204
1250.0999755859375, 4.758244292412945
1250.800048828125, 0.0
1251.5999755859375, 0.06918287339534168
1252.5, 0.45353217003612883
1253.199951171875, 0.6533938042893381
1254.0999755859375, 0.3459143669767084
1254.699951171875, 0.22292259205165654
1255.4000244140625, 0.538089015297102
1258.300048828125, 0.5611499730955493
1259.5999755859375, 2.7211930202167727
1260.4000244140625, 3.228534091782612
1261.0, 4.18940733338458
1262.699951171875, 1.7680067645476207
1264.300048828125, 4.481512798831578
1265.4000244140625, 0.5150280574986548
1266.4000244140625, 0.4689061419017603
1267.699951171875, 1.2760396648474133
1268.4000244140625, 0.06149588746252594
1269.800048828125, 0.8301944807441002
1271.0, 0.42278422630486584
1271.5, 0.33822738104389266
1272.699951171875, 3.6282573602890307
1277.0, 0.4612191559689445
1277.699951171875, 0.5227150434314705
1279.0999755859375, 1.1299869321239142
1279.699951171875, 0.5534629871627335
1280.300048828125, 0.1076178030594204
1283.0, 1.883311553539857
1284.0, 2.0985471596586978
1284.5999755859375, 0.8916903682066262
1285.300048828125, 0.4458451841033131
1288.800048828125, 0.4689061419017603
1290.800048828125, 2.4675224844338532
1291.9000244140625, 0.31516642324544547
1292.5, 0.3766623107079714
1294.199951171875, 0.04612191559689446
1295.699951171875, 0.33822738104389266
1296.5999755859375, 2.1369820893227764
1297.5999755859375, 2.175417018986855
1300.199951171875, 2.4905834422323005
1302.4000244140625, 2.4290875547697746
1303.300048828125, 0.4458451841033131
1304.300048828125, 0.11530478899223613
1305.800048828125, 2.421400568836959
1307.199951171875, 0.06918287339534168
1307.9000244140625, 0.20754862018602505
1308.699951171875, 0.6457068183565223
1310.199951171875, 4.258590206779921
1311.0, 0.19217464832039358
1312.699951171875, 1.3375355523099393
1313.4000244140625, 0.038434929664078715
1314.699951171875, 0.922438311937889
1315.9000244140625, 0.31516642324544547
1316.4000244140625, 0.03074794373126297
1317.300048828125, 0.5918979168268121
1318.699951171875, 3.036359443462218
1319.800048828125, 0.1076178030594204
1321.4000244140625, 6.610807902221539
1321.9000244140625, 1.7449458067491737
1322.699951171875, 0.43815819817049734
1323.4000244140625, 0.745637635483127
1324.4000244140625, 0.22292259205165654
1326.0999755859375, 0.015373971865631485
1327.300048828125, 0.40741025443923434
1328.300048828125, 0.38434929664078715
1329.0, 0.23060957798447226
1330.5999755859375, 0.7610116073487585
1331.699951171875, 0.16911369052194633
1332.9000244140625, 2.7365669920824045
1333.800048828125, 1.522023214697517
1334.4000244140625, 0.35360135290952416
1337.0, 2.7673149358136673
1338.199951171875, 0.3074794373126297
1339.300048828125, 0.22292259205165654
1340.0, 0.38434929664078715
1340.5, 0.4689061419017603
1341.199951171875, 0.31516642324544547
1343.0999755859375, 4.435390883234684
1344.5, 0.33822738104389266
1345.5999755859375, 0.24598354985010376
1346.4000244140625, 0.5304020293642863
1347.199951171875, 1.4220923975709123
1348.300048828125, 0.5918979168268121
1351.5999755859375, 1.6911369052194634
1352.199951171875, 0.4919670997002075
1352.5999755859375, 0.3766623107079714
1354.9000244140625, 4.466138826965946
1355.5, 2.3214697517103544
1357.0999755859375, 0.19217464832039358
1357.800048828125, 0.5534629871627335
1358.9000244140625, 0.6303328464908909
1359.699951171875, 0.22292259205165654
1360.199951171875, 0.015373971865631485
1360.800048828125, 0.13836574679068336
1362.300048828125, 6.556999000691828
1363.199951171875, 0.08455684526097317
1363.9000244140625, 0.2767314935813667
1365.5999755859375, 5.250211392113152
1366.5, 0.1998616342532093
1367.300048828125, 0.20754862018602505
1369.0999755859375, 1.998616342532093
1369.9000244140625, 0.36897532477515566
1371.4000244140625, 2.659697132754247
1372.5, 0.299792451379814
1373.0999755859375, 0.1076178030594204
1373.9000244140625, 0.5611499730955493
1376.199951171875, 3.4822046275655314
1377.4000244140625, 2.8441847951418247
1379.0, 0.49965408563302327
1379.699951171875, 0.6610807902221538
1381.4000244140625, 3.4822046275655314
1383.699951171875, 9.332000922438311
1384.5999755859375, 2.9748635559996925
1385.199951171875, 0.3305403951110769
1387.0999755859375, 2.4675224844338532
1388.699951171875, 0.04612191559689446
1389.4000244140625, 0.07686985932815743
1390.300048828125, 0.3997232685064186
1391.800048828125, 0.16911369052194633
1392.5, 0.12299177492505188
1394.5999755859375, 2.1907909908524865
1396.199951171875, 2.359904681374433
1397.800048828125, 0.16142670458913058
1399.300048828125, 2.167730033054039
1399.9000244140625, 1.6296410177569374
1402.5, 1.5066492428318856
1403.199951171875, 0.13836574679068336
1404.0, 0.7994465370128372
1405.0999755859375, 0.238296563917288
1405.5, 0.13836574679068336
1407.4000244140625, 2.9441156122684293
1408.4000244140625, 0.1998616342532093
1409.5, 1.729571834883542
1410.199951171875, 0.5457760012299178
1411.0999755859375, 5.350142209239757
1414.300048828125, 2.982550541932508
1415.4000244140625, 1.6603889614882004
1416.0999755859375, 2.0985471596586978
1416.5999755859375, 2.513644400030748
1417.5999755859375, 0.4919670997002075
1418.5999755859375, 1.0069951571988622
1420.4000244140625, 3.0132984856637712
1421.0999755859375, 0.1460527327234991
1421.5, 0.13836574679068336
1422.5999755859375, 0.4458451841033131
1423.0999755859375, 0.2921054654469982
1424.699951171875, 0.983934199400415
1426.300048828125, 2.9056806826043506
1427.4000244140625, 5.319394265508494
1429.0, 2.0216773003305404
1429.9000244140625, 0.2767314935813667
1430.4000244140625, 0.09993081712660465
1432.800048828125, 0.22292259205165654
1434.0999755859375, 1.3605965101083863
1435.300048828125, 2.3675916673072486
1436.9000244140625, 4.012606656929818
1438.5, 2.9518025982012452
1439.199951171875, 0.24598354985010376
1440.0, 0.22292259205165654
1440.9000244140625, 0.35360135290952416
1441.800048828125, 0.1460527327234991
1442.5999755859375, 0.0538089015297102
1444.5, 0.3766623107079714
1446.0999755859375, 1.1453609039895456
1447.0, 0.3997232685064186
1447.5999755859375, 0.18448766238757783
##END NTUPLES

`;

export default lcmsJcamp2;
